import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import {
  Input,
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Box,
  Link,
  TextField,
  Pagination,
  Modal,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  InputAdornment,
  CircularProgress,
  Divider,
  OutlinedInput,
  ListItemText,
  Checkbox,
  Chip,
  Skeleton
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import moment from 'moment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ToastContainer, toast } from 'react-toastify';
import { Icon } from '@iconify/react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Navigate, useNavigate, useNavigation, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import CustomComplete from '../components/customComplete/CustomComplete';

import countries from './countryJson/countryJson.json';
import { Api, UploadFile } from '../webservices';

import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar/Scrollbar';

const styleClients = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '60%', sm: '80%' },
  bgcolor: 'background.paper',
  border: '3px solid #3C6BA5',
  boxShadow: 24,
  p: 3,
  borderRadius: 3,
};

function Clients() {
  // const role = useSelector((state) => state.userData.data.role);
  const contactPer1 = useSelector((state) => state.userData.data.contactPersonName);
const role = localStorage.getItem('role');
  console.log("role===>>", role)
  // const[contactPer, setContactPerson] = useState(localStorage.getItems("contactPersonName"))
  // console.log("===========contactPer1", contactPer1)
  // const navigate = useNavigate();
  const location = useLocation();
  const navigate = useNavigate();
  
  const [pages, setPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  // const handlePage = (event, value) => {
  //   console.log(value);
  //   setPageNumber(value);
  //   getClient(currentTab, value);
  // };
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    // setFormValues({});
    setDocfile('');
  };
  const [uploadLoader, setUploadLoader] = useState(false);
  const [contactErr, setContactErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [clientErr, setClientErr] = useState(false);
  const [docfile, setDocfile] = useState('');
  const [isClientUpdate, setIsClientUpdate] = useState(false);
  const [currentTab, setCurrentTab] = React.useState('Active');
  const [searchResult, setSearchResult] = React.useState();
  const [tableCount, setTableCount] = useState([])

  const [cityAndZip, setCityAndZip] = useState([]);
  const [cityy, setCityy] = useState('');
  const [clientList, setClientList] = useState([]);
  const [startDatee, setStartDate] = useState(dayjs());
  const [formValues, setFormValues] = useState({
    _id: '',
    addedBy: '',
    addedById: '',
    email: '',
    additionalEmail: '',
    linkedinUrl: '',
    mainContactName: '',
    websiteUrl: '',
    phone: '',
    completeAddress: '',
    salesPerson: '',
    employeeNo: '',
    location: '',
    currentStatus: '',
    domain: '',
    industry: '',
    RPO_Staffing: 'RPO',
    status: 'Active',
    amountType: '',
    contractDate: '',
    amountValue: '',
    clientSource: '',
    contractUrl: '',
    direct: '',
    createdAt: '',
    companyID: '',
    ClientName: '',
    subPlan: 'month',
    country: localStorage.getItem("country"),
  });

  useEffect(() => {
    getClient('Active');
  }, []);

const [err, setErr] = useState(false); 
  const [helperText, setHelperText] = useState(''); 
  const getCity = async (val) => {
    setHelperText('')
    setErr(false)
    setCityAndZip([]);
    const token = localStorage.getItem('token');
    const body = {
      country: formValues.country,
      query: val,
    };
    Api(`resume/get_city_states`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            setCityAndZip(response.data.data);
            // setCityandstate(response.data.data[0]);
            // console.log('=======city and State', response.data.data[0].zip);
          } else {
            // toast.error(response.data.message)
            setHelperText("No cities found for the given city name.")
        setErr(true)
            // setCityAndZip(response.data.data);
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };
  const childFuc = (e) => {
    // console.log('e', e);
    setCityy(e);
    // setValue({ ...value, location: e });
    if (e.length >= 3) getCity(e);
  };
  const fullVal = (val) => {
    setCityy(`${val.city} ${val.stateCode} ${val.zip || val.postal}`);
    // setCityy(`${val.city} (${val.state}) (${val.zip})`);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 3,
  };

  const [loadingAdd, setLoadingAdd] = useState(false)

  const addClient = () => {
    setLoadingAdd(true)
    const token = localStorage.getItem('token');
    if (formValues?.ClientName !== '') {
      if (formValues?.email !== '') {
        if (formValues?.mainContactName !== '') {
          Api('company/generate/id', 'GET', '', token).then((Response) => {
            if (Response.status === 200) {
              if (Response.data.code === 200) {
                // console.log('Response', Response?.data?.clientCompanyId);
                addClientt(Response?.data?.clientCompanyId);
              }
            }
          });
        } else {
          setContactErr(true);
          toast.warn('Please Enter Main Contact Name', +'!');
          setLoadingAdd(false)
        }
      } else {
        setEmailErr(true);
        toast.warn('Please Enter Email', +'!');
        setLoadingAdd(false)
      }
    } else {
      setClientErr(true);
      toast.warn('Please EnterClient Name', +'!');
      setLoadingAdd(false)
    }

  };
  const addClientt = (ccId) => {
    
    const token = localStorage.getItem('token');
    const body = {
      clientCompanyId: formValues?.companyID === "" ? ccId : formValues?.companyID,
      // companyID: formValues.companyID,
      email: formValues.email,
      startDate: startDatee,
      additionalEmail: formValues.additionalEmail,
      linkedinUrl: formValues.linkedinUrl,
      contactPersonName: formValues.mainContactName,
      websiteUrl: formValues.websiteUrl,
      domain: formValues.domain,
      contactNoWithISD: formValues.phone,
      industry: formValues.industry,
      RPO_Staffing: formValues.RPO_Staffing,
      status: formValues.status,
      amountType: formValues.amountType,
      contractDate: formValues.contractDate,
      amountValue: formValues.amountValue,
      clientSource: formValues.clientSource,
      contractUrl: formValues.contractUrl,
      address: formValues.completeAddress,
      salesPerson: contactPer1 || formValues.salesPerson,
      employeeNo: formValues.employeeNo,
      location: cityy,
      country: formValues.country,
      clientName: formValues.ClientName,
      companyName: formValues.ClientName,
      subPlan: formValues.amountType === 'Subscription' ? formValues.subPlan : '',
      billingDate: formValues.amountType === 'Subscription' ? formValues.billingDate : '',
    };
    Api('company/add_new_client', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          handleClose();
          setFormValues({
            ...formValues, status: 'Active',
            email: '',
            additionalEmail: '',
            linkedinUrl: '',
            mainContactName: '',
            websiteUrl: '',
            phone: '',
            completeAddress: '',
            salesPerson: '',
            employeeNo: '',
            location: '',
            currentStatus: '',
            domain: '',
            industry: '',
            amountType: '',
            contractDate: '',
            amountValue: '',
            clientSource: '',
            contractUrl: '',
            direct: '',
            createdAt: '',
            companyID: '',
            ClientName: '',
          })
          setCityy('')
          toast.success(Response.data.message);
          getClient('Active');
          setLoadingAdd(false)
        } else {
          // alert("A")
          toast.warn(Response.data.error, +'!');
          setLoadingAdd(false)
        }
      } else {
        // alert("K")
        toast.warn(Response.data.error, +'!');
        setLoadingAdd(false)
      }
    });
  };

  // console.log("formValues.companyID", formValues.companyID)
  const pdfUpload = async (file) => {
    setUploadLoader(true);
    setDocfile(file.name);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'contract');
    UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
      // console.log('=====upload Response========>', Response.data);
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          setUploadLoader(false);
          toast.success(Response.data.status, +'!');
          setFormValues({ ...formValues, contractUrl: Response.data.filePath });
        } else {
          // console.log('=====404=gst===', Response.data.message);
          toast.warn(Response.data.status, +'!');
        }
      } else {
        toast.warn(Response.data.message, +'!');
      }
    });
  };

  const [dataLoading, setDataLoading] = useState(false)

  const openLoadingData = () => {
    // setDataLoading(true)
  }

  const closeLoadingData = () => {
    setDataLoading(false)
  }

  const getClient = (val, value) => {
    openLoadingData()
    setClientList([])
    setLoading("Loading...")
    setCurrentTab(val || '');
    setTableCount([])
    const token = localStorage.getItem('token');
    const body = {
      status: val,
      page: value || 1,
      limit: '35',
    };
    Api('company/direct_converted', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setLoading("")
            setTableCount(Response.data.count)
            setClientList(Response.data.data);
            const totalPage = Math.ceil(Response.data.count / 35);
            setPages(totalPage);
            closeLoadingData()
          } else {
            setLoading("No Data Found")
            setClientList([])
            closeLoadingData()
          }
        }
      } else {
        toast.warn(Response.data.error, +'!');
        closeLoadingData()
      }
    });
  };

  const styleLoading = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: { xs: '95%', sm: '70%' },
    // width: { xs: '85%', sm: '60%' },
    bgcolor: 'background.paper',
    // border: '3px solid #3C6BA5',
    // boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const editClientDetail = (defaultVal) => {
    setFormValues(defaultVal);
    setIsClientUpdate(true);
    handleOpen();
  };

  const handleTabs = (val) => {
    // setCurrentTab(val);
    getClient(val);
  };

  const searchDataFun = (data, count, totalPage) => {
    // alert('hhh')
    setClientList(null)
    setTableCount(count)
    if (currentTab !== 'active') {
      setClientList('active')
    }
    setClientList(data)
    setSearchResult(data?.length)
    setPages(totalPage)
  }

  const resetTable = () => {
    getClient('Active');
  }


  const [tableShow, setTableShow] = useState(true)
  const [searchCall, setSearchCall] = useState(false)
  const hidePage = () => {
    // alert('hello')
    setTableShow(false)
    setSearchCall(true)
  }

  const showtable = () => {
    setTableShow(true)
  }

  const [loading, setLoading] = useState("")

  useEffect(() => {

  }, [loading]);

  const Domains = [
    "Information Technology",
    "Engineering",
    "Construction",
    "Manufacturing",
    "Healthcare",
    "Production",
    "Automation & Controls",
    "Finance & Accounting",
    "Fintech",
    "Banking",
    "E-Commerce",
    "Supply Chain Management",
    "Science & Innovation",
    "Hospitality",
    "Food & Drink",
    "Real Estate",
    "Energy",
    "Sales",
    "Retail",
    'Trading &  Stocks',
    "Oil & Gas",
    "Logistics",
    "Aerospace",
    "Mining",
    "Pharmaceuticals",
    "Agriculture",
    "Insurance",
    "Gaming",
    "Travel & Tourism",
    "Educational",
    "Edtech",
    "Telecommunication",
    "Gov",
    "Defense",
    "Media & Entertainment",
    "Marketing",
    "Advertising",
    "Others"
  ]

  const searchFnRef = useRef(() => { });
  const [loadingData1, setLoadingData1] = useState('')
  const handleDataFromChild1 = (fn, loadingData) => {
    setPageNumber(1)
    setLoadingData1(loadingData)
    // console.log("Received fn:", fn);
    if (typeof fn === 'function') {
      searchFnRef.current = fn;
    } else {
      // console.error("Received fn is not a function!");
    }
  };

  const handlePage = (event, value) => {
    // console.log("Current searchFn:", searchFnRef.current);
    if (searchCall) {
      setLoading(loadingData1)
      // setPageNumber(1)
      if (typeof searchFnRef.current === 'function') {
        searchFnRef.current(value);
        setPageNumber(value);
      } else {
        // console.error("searchFn is undefined or not a function");
      }
    } else {
      setPageNumber(value);
      getClient(currentTab, value);
    }
  };

  // const [pageNumber1, setPageNumber1] = useState()

  const handleDataFromChild2 = (number) => {
    // setPageNumber1(number)
    setPageNumber(number)
  };

  // console.log("pageNumber", pageNumber)
  const tablebg = 'rgba(82, 130, 190, 0.08)';
  return (
    <>
    <Helmet>
        <title> Clients | Foxearch </title>
      </Helmet>
      <Modal open={dataLoading}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%', 
            transform: 'translate(-50%, -50%)',
            width: { xs: '80%', sm: '50%', md: '20%' },
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 3,
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Stack spacing={2} alignItems="center">
            <CircularProgress />
            <Typography variant="h6" sx={{ color: 'text.secondary', wordWrap: 'break-word' }}>
              Loading...
            </Typography>
          </Stack>
        </Box>
      </Modal>

      <Search searchData={searchDataFun} func={resetTable} funcc={hidePage} funnc={showtable}
        onData1={handleDataFromChild1}
        onData2={handleDataFromChild2}
        resetSearch={() => setSearchResult('')} />
      <ToastContainer />
      <Stack flexDirection={'row'} alignItems={'flex-end'} justifyContent={'space-between'}>
        <Typography variant="h5" color={'text.secondary'}>
          Clients
        </Typography>

        {role === 'admin' || role === 'salesHead' || role === "salesManager" || role === "salesTeamLead" || role === "salesExecutive" || role === "salesTrainee" || role === 'recruiterHead' || role === 'recruiterManager' ? (
          <Button color="custom" variant="contained" size="small" onClick={handleOpen}>
            Add Client
          </Button>
        ) : null}
      </Stack>

      {!tableShow && (

        <Typography sx={{ float: "right", mt: 0.5 }} fontSize={"0.85rem"} color={'text.secondary'}>
          Total: {searchResult || "0"}
        </Typography>
      )}

      <Stack sx={{ flexDirection: 'row', gap: 2, mb: 0.5, cursor: 'pointer', alignItems: 'center' }}>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === '' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('');
          }}
        >
          <Iconify icon="mingcute:list-check-line" fontSize={17} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            All
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === 'Active' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('Active');
          }}
        >
          <Iconify
            icon="iconamoon:star-thin"
            fontSize={17}
            color={currentTab === 'Active' ? '#2ECC71' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Active Clients
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === 'On Hold' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('On Hold');
          }}
        >
          <Iconify icon="mynaui:pause" fontSize={17} color={currentTab === 'On Hold' ? '#F4D03F' : 'text.textG'} />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            On Hold
          </Typography>
        </Stack>
        <Stack
          sx={[
            { flexDirection: 'row' },
            currentTab === 'Inactive' ? { borderBottom: 3, color: 'text.secondary' } : { color: 'text.textG' },
          ]}
          onClick={() => {
            handleTabs('Inactive');
          }}
        >
          <Iconify
            icon="jam:triangle-danger"
            fontSize={17}
            color={currentTab === 'Inactive' ? '#CB4335' : 'text.textG'}
          />
          <Typography variant="tabs" sx={{ ml: 1 }}>
            Inactive Clients
          </Typography>
        </Stack>
      </Stack>

      <TableContainer component={Paper} sx={{}}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ justifyContent: 'flex-start', backgroundColor: 'text.secondary' }}>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Date</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '18%' }}>Client Info</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '18%' }}>Contact</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '12%' }}>Client Info</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Jobs</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Activity</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Status</TableCell>
              <TableCell sx={{ p: 1, py: 0.5, color: 'white', width: '10%' }}>Invoice</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientList?.map((item, index) => (
              <ClientRow
                key={item._id}
                row={item}
                index={index}
                editClient={editClientDetail}
                hitClient={getClient}
                role={role}
                currentTab={currentTab}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* {clientList.length < 1 && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>no data found</Typography>
        </Stack>
      )} */}
      {/* {loading !== "" && (
        <Stack sx={{ mt: 2, p: 2 }}>
          <Typography sx={{ alignSelf: 'center', color: 'red' }}>{loading}</Typography>
        </Stack>
      )} */}

{loading === "Loading..." ? (
      <Stack>
  {Array.from({ length: 15 })?.map((_, index) => (
    <Skeleton
      key={index}
      variant="rectangular"
      sx={{
        height: 80, 
        width: '100%',
        backgroundColor: index % 2 === 0 ? 'text.background' : tablebg,
      }}
    />
  ))}
</Stack>     

      ):
      <Stack sx={{ mt: 2, p: 2 }}>
           <Typography sx={{ alignSelf: 'center', color: 'red' }}>
             {loading}
            
             </Typography>
         </Stack> 
      } 

      {/* {tableShow && (
        <>

          {clientList?.length > 1 ? (
            <Stack spacing={2} sx={{ alignItems: 'flex-end', width: '100%', mt: 2 }}>
              <Pagination
                variant="outlined"
                shape="rounded"
                color="secondary"
                count={pages}
                page={pageNumber}
                onChange={handlePage}
              />
            </Stack>
          ) : null}
        </>
      )} */}

      {/* {dataaa && (
        <> */}
      {tableCount > 35 ? (
        <Stack
          spacing={2}
          sx={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2
          }}
        >
          {/* {pageNumber !== 1 && ( */}
          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px',
              mt: 2,
              ml: 0.5, cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.max(prev - 1, 1))}
          >
            {"<"}
          </Button>
          {/* )} */}

          <Pagination
            variant="outlined"
            shape="rounded"
            color="secondary"
            hideNextButton
            hidePrevButton
            count={pages}
            page={pageNumber}
            onChange={handlePage}
            sx={{ cursor: 'pointer', mb: (pageNumber !== 1) ? -4 : -2 }}
          />
          {/* {pageNumber !== pages && ( */}
          <Button
            variant="outlined"
            sx={{
              minWidth: 16, height: 32, borderRadius: '5px', mr: 1,
              mt: -2,
              cursor: 'pointer'
            }}
            onClick={() => setPageNumber(prev => Math.min(prev + 1, pages))}
          >
            {">"}
          </Button>
          {/* )} */}
        </Stack>

      ) : null}
      {/* </>
      )} */}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={[styleClients, { width: { xs: '95%', sm: '75%' } }]}>
          <Typography variant="h5" textAlign={'center'} color={'text.secondary'}>
            Add Client
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(1, 1fr)' }} py={1} gap={2}>
              <Stack gap={2}>
                <TextField
                  id="outlined-basic"
                  label="Client Id"
                  placeholder="Enter Manually / Automatically Assigned if Blank"
                  variant="outlined"
                  value={formValues?.companyID}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, companyID: e.target.value })}
                />
                <TextField
                  error={clientErr}
                  required
                  id="outlined-basic"
                  label="Client Name"
                  placeholder="Client Name"
                  variant="outlined"
                  value={formValues?.ClientName}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setFormValues({ ...formValues, ClientName: e.target.value })
                    if (formValues?.ClientName !== "") {
                      setClientErr(false)
                    } else {
                      setClientErr(true)
                    }
                  }}
                />

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Domain</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formValues?.domain}
                    label="Domain"
                    // InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, domain: e.target.value })}
                  >
                    {Domains.map((item) => {
                      return <MenuItem value={item}>{item}</MenuItem>
                    })}

                  </Select>
                </FormControl>

                {/* <TextField
                  id="outlined-basic"
                  label="Domain"
                  placeholder="Domain"
                  variant="outlined"
                  value={formValues?.domain}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, domain: e.target.value })}
                /> */}

                <TextField
                  id="outlined-basic"
                  label="Phone"
                  placeholder="Phone"
                  variant="outlined"
                  value={formValues.phone}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, phone: e.target.value })}
                />
                <TextField
                  id="outlined-basic"
                  label="Linkedin URL"
                  placeholder="Linkedin URL"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={formValues?.linkedinUrl}
                  // onChange={(e) => setFormValues({ ...formValues, linkedinUrl: e.target.value })}

                  onChange={(e) => {
                    let updatedUrl = e.target.value.trim();
                    updatedUrl = updatedUrl.replace(/^(https?:\/\/)?(www\.)?/i, '');

                    if (updatedUrl.startsWith('www')) {
                      updatedUrl = `https://${updatedUrl}`;
                    } else if (updatedUrl !== '') {
                      updatedUrl = `https://www.${updatedUrl}`;
                    }

                    setFormValues({ ...formValues, linkedinUrl: updatedUrl });
                  }}

                />
                {/* <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Industry</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Industry"
                    placeholder="Industry"
                    value={formValues?.industry}
                    onChange={(e) => setFormValues({ ...formValues, industry: e.target.value })}
                  >
                    <MenuItem value="IT">IT</MenuItem>
                    <MenuItem value="Healthcare">Healthcare</MenuItem>
                    <MenuItem value="Engineering">Engineering</MenuItem>
                    <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                    <MenuItem value="non IT">non IT</MenuItem>
                    <MenuItem value="Finance">Finance</MenuItem>
                    <MenuItem value="Pharma">Pharma</MenuItem>
                    <MenuItem value="Hospitality">Hospitality</MenuItem>
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl> */}
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Country</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Country"
                    placeholder="Country"
                    value={formValues.country}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, country: e.target.value })}
                  >
                    {/* <MenuItem value={'USA'}>USA</MenuItem>;
                    <MenuItem value={'CANADA'}>CANADA</MenuItem>;
                     <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                     {countries?.map((item) => (
      <MenuItem key={item.id} value={item.country}>
        {item.country}
      </MenuItem>
    ))}
                  </Select>
                </FormControl>
                <FormControl>
                  <CustomComplete
                    placeholder={'City'}
                    option={cityAndZip}
                    propVal={cityy}
                    childFuc={childFuc}
                    fullVal={fullVal}
                    fetch={'state'}
                    err={err}
                  helperText={helperText}
                  />
                </FormControl>
                {/* <TextField
                  id="outlined-basic"
                  label="location"
                  placeholder="location"
                  variant="outlined"
                  value={formValues?.location}
                  onChange={(e) => setFormValues({ ...formValues, location: e.target.value })}
                /> */}
                <TextField
                  id="outlined-basic"
                  label="Industry"
                  placeholder="Industry"
                  variant="outlined"
                  value={formValues?.industry}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, industry: e.target.value })}
                />

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Client Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Client type"
                    placeholder="Client type"
                    value={formValues.RPO_Staffing}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, RPO_Staffing: e.target.value })}
                  >
                    <MenuItem value="RPO">RPO</MenuItem>
                    <MenuItem value="Staffing">Staffing</MenuItem>
                    <MenuItem value="Consulting">Consulting</MenuItem>
                    <MenuItem value="MSP">MSP</MenuItem>
                    <MenuItem value="Contingent">Contingent</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>

                <FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      sx={{ width: '100%' }}
                      label={'Contract Signed Date'}
                      value={dayjs(formValues?.contractDate)}
                      onChange={(e) => setFormValues({ ...formValues, contractDate: e })}
                    />
                  </LocalizationProvider>
                </FormControl>

                <TextField
                  id="outlined-basic"
                  label="Client Source"
                  placeholder="Client Source"
                  variant="outlined"
                  value={formValues?.clientSource}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, clientSource: e.target.value })}
                />

                <Stack sx={{ position: 'relative' }}>
                  <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Stack
                      sx={{
                        cursor: 'pointer',
                        m: 1,
                        border: 1,
                        p: 1,
                        borderRadius: 2,
                        width: 'fit-content',
                        borderColor: 'text.secondary',
                      }}
                    >
                      <Typography sx={{ alignSelf: 'center' }} color={'text.secondary'}>
                        Upload Contract
                      </Typography>
                    </Stack>
                    <input
                      style={{ opacity: 0, position: 'absolute', margin: 5, width: 100 }}
                      type="file"
                      onChange={(e) => {
                        pdfUpload(e.target.files[0]);
                      }}
                    />
                    {uploadLoader && <CircularProgress />}
                  </Stack>
                  {formValues.contractUrl || docfile ? (
                    <Typography>{docfile || 'Contract already Uploaded!'}</Typography>
                  ) : null}
                </Stack>
              </Stack>
              <Stack gap={2}>
                <TextField
                  error={emailErr}
                  required
                  id="outlined-basic"
                  label="Email"
                  placeholder="Email"
                  variant="outlined"
                  value={formValues?.email}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setFormValues({ ...formValues, email: e.target.value });
                    if (formValues.email !== "") {
                      setEmailErr(false)
                    } else {
                      setEmailErr(true)
                    }
                  }}
                />
                {/* <TextField
                  id="outlined-basic"
                  label="Start Date"
                  multiline
                  placeholder="Start Date"
                  variant="outlined"
                  value={formValues?.additionalEmail}
                  onChange={(e) => setFormValues({ ...formValues, additionalEmail: e.target.value })}
                /> */}
                <FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer sx={{ mt: -0.8 }} components={['DatePicker', 'DatePicker']}>
                      <DatePicker
                        sx={{ width: '100%' }}
                        label={'Start Date'}
                        value={startDatee}
                        onChange={(e) => {
                          setStartDate(e);
                          // console.log('e', e);
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </FormControl>
                <TextField
                  id="outlined-basic"
                  label="Number of Employees"
                  placeholder="Number of Employees"
                  variant="outlined"
                  value={formValues?.employeeNo}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, employeeNo: e.target.value })}
                />
                <TextField
                  error={contactErr}
                  required
                  id="outlined-basic"
                  label=" Main Contact Name"
                  placeholder="Main Contact Name"
                  variant="outlined"
                  value={formValues.mainContactName}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setFormValues({ ...formValues, mainContactName: e.target.value })
                    if (formValues.mainContactName !== "") {
                      setContactErr(false)
                    } else {
                      setContactErr(true)
                    }
                  }}
                />

                <TextField
                  id="outlined-basic"
                  label="Website URL"
                  placeholder="Website URL"
                  variant="outlined"
                  value={formValues?.websiteUrl}
                  InputLabelProps={{ shrink: true }}
                  // onChange={(e) => setFormValues({ ...formValues, websiteUrl: e.target.value })}

                  onChange={(e) => {
                    let updatedUrl = e.target.value.trim();
                    updatedUrl = updatedUrl.replace(/^(https?:\/\/)?(www\.)?/i, '');

                    if (updatedUrl.startsWith('www')) {
                      updatedUrl = `https://${updatedUrl}`;
                    } else if (updatedUrl !== '') {
                      updatedUrl = `https://www.${updatedUrl}`;
                    }

                    setFormValues({ ...formValues, websiteUrl: updatedUrl });
                  }}
                />
                <TextField
                  id="outlined-basic"
                  label="Complete  Address"
                  placeholder="Complete Address"
                  variant="outlined"
                  value={formValues?.completeAddress}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, completeAddress: e.target.value })}
                />

                <FormControl size="small" fullWidth sx={{ mt: -0.6 }}>
                  <FormLabel id="demo-radio-buttons-group-label">Fees Type</FormLabel>
                  <RadioGroup
                    size="small"
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="Amount Type"
                    name="radio-buttons-group"
                    sx={{ flexDirection: 'row' }}
                    value={formValues?.amountType}
                    onChange={(e) => setFormValues({ ...formValues, amountType: e.target.value })}
                  >
                    <FormControlLabel value="Percentage Basis" label="Percentage" control={<Radio size="small" />} />
                    <FormControlLabel value="Flat Fee" label="Flat Fee" control={<Radio size="small" />} />
                    <FormControlLabel value="Margin Basis" label="Margin" control={<Radio size="small" />} />
                    <FormControlLabel value="Subscription" label="Subscription" control={<Radio size="small" />} />
                  </RadioGroup>
                </FormControl>
                {formValues.amountType === 'Subscription' ? (
                  <>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Subscription Plan</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Subscription Plan"
                        placeholder="Subscription Plan"
                        value={formValues.subPlan}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => setFormValues({ ...formValues, subPlan: e.target.value })}
                      >
                        <MenuItem value="month">Month</MenuItem>
                        <MenuItem value="quater">Quater</MenuItem>
                        <MenuItem value="year">Year</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      id="outlined-basic"
                      label=""
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        endAdornment: <InputAdornment position="end">per/{formValues?.subPlan}</InputAdornment>,
                      }}
                      value={formValues?.amountValue}
                      onChange={(e) => setFormValues({ ...formValues, amountValue: e.target.value })}
                    />
                    <FormControl>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={{ width: '100%' }}
                          label={'Billing Date'}
                          value={dayjs(formValues.billingDate)}
                          onChange={(e) => setFormValues({ ...formValues, billingDate: e })}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </>
                ) : (
                  <TextField
                    id="outlined-basic"
                    label={'Fee Type'}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {formValues?.amountType !== 'Percentage Basis' ? '$' : null}
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          {formValues?.amountType === 'Percentage Basis'
                            ? '%'
                            : formValues?.amountType === 'Margin Basis'
                              ? 'P/H'
                              : 'K'}
                        </InputAdornment>
                      ),
                    }}
                    value={formValues?.amountValue}
                    onChange={(e) => setFormValues({ ...formValues, amountValue: e.target.value })}
                  />
                )}
                <TextField
                  id="outlined-basic"
                  label="Sales Persons"
                  placeholder="Sales Persons"
                  variant="outlined"
                  disabled
                  value={(formValues?.salesPerson) || contactPer1}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, salesPerson: e.target.value })}
                />
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Status"
                    placeholder="Status"
                    value={formValues?.status}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, status: e.target.value })}
                  >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    <MenuItem value="on Hold">on Hold</MenuItem>
                  </Select>
                </FormControl>
                {/* {formValues?.status && (
                      <FormControl>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ width: '100%' }}
                            label={formValues?.RPO_Staffing === 'RPO' ? 'Billing Date' : 'Contract Signed Date'}
                            value={dayjs(formValues?.contractDate)}
                            onChange={(e) =>
                              setFormValues({ ...formValues, contractDate: new Date(e.$d).toLocaleDateString() })
                            }
                          />
                        </LocalizationProvider>
                      </FormControl>
                    )} */}
              </Stack>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button variant="contained" color="custom" 
              onClick={() => addClient()} 
              sx={{ alignSelf: 'center' }}
                disabled={loadingAdd}
              >
                {/* Add Client */}
                 {loadingAdd ? <CircularProgress size={21} /> : 'Add Client'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box> 
      </Modal>
    </>
  );
}

const ClientRow = ({ row, editClient, index, hitClient, role, currentTab }) => {
  const tablebg = 'rgba(82, 130, 190, 0.08)';
  const navigate = useNavigate();
  const [roleUsers, setRoleUsers] = useState([]);
  const [underRole, setUnderRole] = useState([]);
  const [selectUser, setSelectUser] = useState([]);
  const [selectUserId, setSelectUserId] = useState([]);

  const [docfile, setDocfile] = useState('');
  const [startDatee, setStartDate] = useState(dayjs(row.startDate));

  const [actionData, setActionData] = useState([]);
  const [assignee, setAssignee] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [openAss, setOpenAss] = useState(false);
  const assCloses = () => setOpenAss(false);
  const assOpen = () => setOpenAss(true);

  const [member, setMember] = useState('individual');
  const [tempRole, setTempRole] = useState('');
  const [personName, setPersonName] = useState([]);

  const [openD, setOpenD] = useState(false);
  const openDetail = () => {
    getContract();
    setOpenD(true);
  };
  const closeDetail = () => {
    setOpenD(false);
  };

  const [openA, setOpenA] = useState(false);
  const openActivity = () => setOpenA(true);
  const closeActivity = () => setOpenA(false);

  const [openstatus, setOpenstatus] = useState(false);
  const statusCloses = () => setOpenstatus(false);
  const statusOpen = () => setOpenstatus(true);

  const [changeJobstatus, setChangeJobstatus] = useState(false);
  const jobStatusOpen = () => {
    setChangeJobstatus(true);
  };
  const jobStatusCloses = () => {
    setChangeJobstatus(false);
  };

  // const [popupOpen, setPopupOpen] = useState(false);

  const styleSkillset = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: { xs: '60%', sm: '50%' },
    width: '50%',
    bgcolor: 'background.paper',
    border: '3px solid #3C6BA5',
    boxShadow: 24,
    p: 3,
    borderRadius: 3,
  };

  const [openS, setOpenS] = useState(false);
  const openSub = () => {
    setExcelStatus("submitted")
    // handleOpenn()
    statusJobs('submitted', '');
    setOpenS(true);
  };
  const closeSubmission = () => setOpenS(false);

  const [openn, setOpenn] = useState(false);
  const handleOpenn = () => setOpenn(true);
  const handleClosen = () => setOpenn(false);

  const [openI, setOpenI] = useState(false);
  const openInterview = () => {
    setExcelStatus("interview")
    statusJobs('interview', '');
    setOpenI(true);
  };
  const closeInterview = () => setOpenI(false);

  const [openP, setOpenP] = useState(false);
  const openPlacement = () => {
    setExcelStatus("placement")
    statusJobs('placement', '');
    setOpenP(true);
  };
  const closePlacement = () => setOpenP(false);

  const [openT, setOpenT] = useState(false);
  const openTotalJob = () => {
    setOpenT(true);
    totalJobs();
  };
  const closeTotalJob = () => setOpenT(false);

  const [tempData, setTempData] = useState([]);

  const [openJ, setOpenJ] = useState(false);
  const openJob = () => {
    openJobs();
    setOpenJ(true);
  };
  const closeJob = () => setOpenJ(false);
  const [openData, setOpenData] = useState([]);
  const [totalData, setTotalData] = useState([]);

  const [openC, setOpenC] = useState(false);
  const openCandidateDetails = () => setOpenC(true);
  const closeCandidateDetails = () => setOpenC(false);

  const [openClient, setOpenClient] = useState(false);
  const openClientD = () => setOpenClient(true);
  const closeClientD = () => setOpenClient(false);
  const [tabs, setTabs] = useState('Agreement');
  const [upload, setUpload] = useState(false);
  const [resumeArry, setResumeArry] = useState([]);

  const [note, setNote] = useState('');
  const [openEdit, setOpenEdit] = useState(false);
  const editClose = () => setOpenEdit(false);
  const editOpen = () => setOpenEdit(true);
  const [clientUserList, setClientUserList] = useState([]);
  const [openClientlist, setOpenClientlist] = useState(false);
  const openCList = () => setOpenClientlist(true);
  const closeCList = () => setOpenClientlist(false);
  const [allAssign, setAllAssign] = useState(false);
  const [contractUrl, setContractUrl] = useState(row.contractUrl);

  const [statuss, setStatuss] = useState('');
  const [statusDate, setStatusDate] = useState(dayjs());
  const [statusNote, setStatusNote] = useState('');

  const [cityAndZip, setCityAndZip] = useState([]);
  const [cityy, setCityy] = useState(row.location || '');

  const suru = 'https://docs.google.com/viewer?url=';
  const lll = '&embedded=true';
  const [smsValue, setSmsValue] = useState('');
  const [uploadLoader, setUploadLoader] = useState(false);
  const [editAssign, setEditAssign] = useState(false);
  const [unAssignee, setUnAssignee] = useState([]);
  const setEditorSmsValue = (val) => {
    setSmsValue(val);
    // console.log('val', val);
  };

  const [email, setEmail] = useState({
    editor: '',
    Subject: '',
    date: '',
    clientId: '',
    superAdminId: '',
  });
  const [formValues, setFormValues] = useState({
    _id: '',
    addedBy: '',
    addedById: '',
    email: row?.email || '',
    additionalEmail: '',
    linkedinUrl: row?.linkedinUrl || '',
    mainContactName: row?.contactPersonName || '',
    websiteUrl: row?.websiteUrl || '',
    phone: row?.contactNoWithISD || '',
    completeAddress: row?.address || '',
    salesPerson: row?.salesPerson || row?.addedBy,
    employeeNo: row?.employeeNo || '',
    location: row?.location || '',
    currentStatus: row?.currentStatus || '',
    domain: row?.domain || '',
    industry: row?.industry || '',
    RPO_Staffing: row?.RPO_Staffing || '',
    status: row?.status || '',
    amountType: row?.amountType || '',
    contractDate: dayjs(row?.contractDate) || '',
    billingDate: dayjs(row?.billingDate) || '',
    amountValue: row?.amountValue || '',
    clientSource: row?.clientSource || '',
    contractUrl: row?.contractUrl || '',
    direct: row?.direct || '',
    createdAt: '',
    companyID: row?.clientCompanyId || '',
    ClientName: row?.clientName || row?.companyName,
    subPlan: row?.subPlan || 'month',
    country: row?.country || localStorage.getItem("country"),
  });

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { md: '50%', xs: '95%' },
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 3,
  };

  const [err, setErr] = useState(false); 
  const [helperText, setHelperText] = useState('');
  const getCity = async (val) => {
    setHelperText('')
    setErr(false)
    setCityAndZip([]);
    const token = localStorage.getItem('token');
    const body = {
      country: formValues.country,
      query: val,
    };
    Api(`resume/get_city_states`, 'POST', body, token)
      .then((response) => {
        if (response.status === 200) {
          // console.log('=========status 200======>>>>>>>', response);
          if (response.data.code === 200) {
            setCityAndZip(response.data.data);
            // setCityandstate(response.data.data[0]);
            // console.log('=======city and State', response.data.data[0].zip);
          } else {
            // toast.error(response.data.message)
            setHelperText("No cities found for the given city name.")
        setErr(true)
            // setCityAndZip(response.data.data);
            // toast.error(response.data.message, +'!');
          }
        }
      })
      .catch((err) => {
        // console.log('===========', err);
        // toast.error(err, +'!');
      });
  };
  const childFuc = (e) => {
    // console.log('e', e);
    setCityy(e);
    // setValue({ ...value, location: e });
    if (e.length >= 3) getCity(e);
  };
  const fullVal = (val) => {
    setCityy(`${val.city} ${val.stateCode} ${val.zip || val.postal}`);
    // setCityy(`${val.city} (${val.state}) (${val.zip})`);
  };

  const [loadingEdit, setLoadingEdit] = useState(false)

  const UpdateClient = () => {
    setLoadingEdit(true)
    const token = localStorage.getItem('token');
    const body = {
      clientId: row?._id,
      companyID: formValues?.companyID,
      email: formValues?.email,
      startDate: startDatee,
      linkedinUrl: formValues?.linkedinUrl,
      contactPersonName: formValues?.mainContactName,
      websiteUrl: formValues?.websiteUrl,
      domain: formValues?.domain,
      contactNoWithISD: formValues?.phone,
      RPO_Staffing: formValues?.RPO_Staffing,
      status: formValues?.status,
      amountType: formValues?.amountType,
      contractDate: formValues?.contractDate,
      amountValue: formValues?.amountValue,
      clientSource: formValues?.clientSource,
      contractUrl: formValues?.contractUrl,
      address: formValues?.completeAddress,
      salesPerson: formValues?.salesPerson,
      employeeNo: formValues?.employeeNo,
      location: cityy,
      country: formValues?.country,
      industry: formValues?.industry,
      currentStatus: '',
      companyName: formValues?.ClientName,
      clientName: formValues?.ClientName,
      subPlan: formValues?.amountType === 'Subscription' ? formValues?.subPlan : '',
      billingDate: formValues?.amountType === 'Subscription' ? formValues?.billingDate : '',
    };
    Api('company/edit_converted_client', 'POST', body, token).then((Response) => {
      // console.log(Response);
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          // hitClient();
          editClose();

          row.startDate = startDatee;
row.linkedinUrl = formValues?.linkedinUrl;
row.contactPersonName = formValues?.mainContactName;
row.websiteUrl = formValues?.websiteUrl;
row.domain = formValues?.domain;
row.contactNoWithISD = formValues?.phone;
row.RPO_Staffing = formValues?.RPO_Staffing;
row.status = formValues?.status;
row.amountType = formValues?.amountType;
row.contractDate = formValues?.contractDate;
row.amountValue = formValues?.amountValue;
row.clientSource = formValues?.clientSource;
row.contractUrl = formValues?.contractUrl;
row.address = formValues?.completeAddress;
row.salesPerson = formValues?.salesPerson;
row.employeeNo = formValues?.employeeNo;
row.location = cityy;
row.country = formValues?.country;
row.industry = formValues?.industry;
row.currentStatus = '';
row.companyName = formValues?.ClientName;
row.clientName = formValues?.ClientName;
row.subPlan = formValues?.amountType === 'Subscription' ? formValues?.subPlan : '';
row.billingDate = formValues?.amountType === 'Subscription' ? formValues?.billingDate : '';
row.startDate = new Date().toISOString(); 
          toast.success(Response.data.message);
          setLoadingEdit(false)
        } else {
          toast.warn(Response.data.error);
          setLoadingEdit(false)
        }
      } else {
        toast.warn(Response.data.error, +'!');
        setLoadingEdit(false)
      }
    });
  };
 
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }, 'blockquote', 'code-block'], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }, { indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction
      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],
      ['link', 'image', 'video', 'formula'],
      ['clean'],
    ],
  };

  const pdfUpload = async (file) => {
    setUploadLoader(true);
    setDocfile(file.name);
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('document', file);
    formData.append('directoryName', 'contract');
    UploadFile(`resume/upload_resume`, formData, token).then((Response) => {
      // console.log('=====upload Response========>', Response.data);
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          setUploadLoader(false);
          toast.success(Response.data.status, +'!');
          setFormValues({ ...formValues, contractUrl: Response.data.filePath });
        } else {
          // console.log('=====404=gst===', Response.data.message);
          toast.warn(Response.data.status, +'!');
        }
      } else {
        toast.warn(Response.data.message, +'!');
      }
    });
  };
  const getContract = async () => {
    const token = localStorage.getItem('token');
    Api(`company/contracts_by_candidate/${row._id}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          // toast.success(Response.data.message);
          setResumeArry(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };
  const deleteContract = async (cId) => {
    const token = localStorage.getItem('token');
    const body = {
      clientId: row._id,
      contractUrlId: cId,
    };
    Api(`company/del_contract`, 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          getContract();
          // toast.success(Response.data.message);
          // setResumeArry(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };
  const getAllUser = async () => {
    const token = localStorage.getItem('token');
    Api('company/all_users', 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          // toast.success(Response.data.message);
          setAllUsers(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };
  const totalJobs = (val) => {
    const token = localStorage.getItem('token');
    Api(`company/jobsforclient/${row._id}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.totalJobs.length > 0) {
            setTotalData(Response.data.totalJobs);
          }
          // toast.success(Response.data.message);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };
  const openJobs = (val) => {
    const token = localStorage.getItem('token');
    Api(`company/jobsforclient/${row._id}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.totalJobs.length > 0) {
            setOpenData(Response.data.openJobs);
          }
          // toast.success(Response.data.message);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };

  const changeJob = () => {
    const token = localStorage.getItem('token');
    const jobIdd = localStorage.getItem('tempJobId');
    const body = {
      clientId: row._id,
      jobId: jobIdd,
      status: statuss,
    };
    Api(`company/update_job_status`, 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (openT === true) {
            totalJobs();
          } else {
            openJobs();
          }
          jobStatusCloses();
          closeJob();
          closeTotalJob();
          hitClient();
          // toast.success(Response.data.message);
          // setTempData(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };

  const [actionStatus1, setActionStatus1] = useState()

  const statusJobs = (val, data) => {
    setActionStatus1(val)
    const token = localStorage.getItem('token');
    const body = {
      clientId: row._id,
      status: val,
    };
    Api(`company/actions/client`, 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          // toast.success(Response.data.message);
          setTempData(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };
 
  const changeClientStatus = (val) => {
    const token = localStorage.getItem('token');
    const body = {
      clientId: row._id,
      status: statuss,
      note: statusNote,
      date: statusDate,
    };

    Api(`company/update_client_status`, 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          hitClient(statuss);
          // toast.success(Response.data.message);
          // setTempData(Response.data.data);
        }
        setOpenstatus(false);
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };
  const handleChange = (event) => {
    // console.log('event', event.target.value);
    setPersonName(event.target.value);
    setSelectUser([...selectUser, roleUsers[event.target.value]]);
    setSelectUserId([...selectUserId, roleUsers[event.target.value]._id]);
    userUnderRole(roleUsers[event.target.value]._id);
    // const {target: { value }, } = event.target.value[0].contactPersonName;
    // setPersonName(
    //   // On autofill we get a stringified value.
    //   typeof value === 'string' ? value.split(',') : value,
    // );
  };
  const handleRole = (val) => {
    setPersonName([]);
    const token = localStorage.getItem('token');
    Api(`company/userbyrole/${val}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setRoleUsers(Response.data.data);
          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
      }
    });
  };
  const userUnderRole = (val) => {
    const token = localStorage.getItem('token');
    Api(`company/underusers/${val}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setUnderRole([...underRole, Response.data.data]);
          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
      }
    });
  };
  const handleRoleUser = (index) => {
    selectUser.splice(index, 1);
    setSelectUser([...selectUser]);
    selectUserId.splice(index, 1);
    setSelectUserId([...selectUserId]);
    // console.log('selectUserId', selectUserId);
  };
  const asignData = (val) => {
    if (val.target.checked) {
      setAssignee([...assignee, val.target.value]);
    } else {
      assignee.forEach((item, index) => {
        if (item === val.target.value) {
          assignee.splice(index, 1);
          setAssignee(assignee);
        }
      });
    }
  };
  const unAsignData = (val) => {
    if (val.target.checked) {
      setUnAssignee([...unAssignee, val.target.value]);
    } else {
      unAssignee.forEach((item, index) => {
        if (item === val.target.value) {
          unAssignee.splice(index, 1);
          setUnAssignee(unAssignee);
        }
      });
    }
  };
  const AllAsignData = (val) => {
    const tempData = [];

    setAllAssign(true);
    allUsers.forEach((item) => {
      tempData.push(item._id);
      // console.log('all-', item._id);
    });
    setAssignee(tempData);
  };
  const [loadingAssignee, setLoadingAssignee] = useState(false)
  const assignClient = async () => {
    setLoadingAssignee(true)
    const token = localStorage.getItem('token');
    const body = {
      clientId: row._id,
      clientAssignedTo: member === 'team' ? selectUserId : assignee,
      assignType: member === 'team' ? 'team' : 'individual',
    };
    Api('company/assign_client', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          assCloses();
          toast.success(Response.data.message);
          // setActionData(Response.data.data);
          setAssignee([])
          setLoadingAssignee(false)
        } else {
          setLoadingAssignee(false)
        }
      } else {
        toast.warn(Response.data.error, +'!');
        setLoadingAssignee(false)
        toast.warn(Response.data.resmessage);
        setAssignee([])
      }
    });
  };
  const unAssignClient = async () => {
    const token = localStorage.getItem('token');
    const body = {
      clientId: row._id,
      usersToUnassign: unAssignee,
    };
    Api('company/remove_client', 'POST', body, token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          setEditAssign(false);
          closeCList();
          toast.success(Response.data.message);
          // setActionData(Response.data.data);
        }
      } else {
        toast.warn(Response.data.error, +'!');
      }
    });
  };

  const clientUser = async () => {
    openCList();
    const token = localStorage.getItem('token');
    Api(`company/users_for_client/${row._id}`, 'GET', '', token).then((Response) => {
      if (Response.status === 200) {
        if (Response.data.code === 200) {
          if (Response.data.data.length) {
            setClientUserList(Response.data.data);
          } else {
            toast.warn(Response.data.message);
          }
        }
      } else {
        toast.error(Response.data.error, +'!');
      }
    });
  };

  // console.log("row===>>>>", row)

  const Domains = [
    "Information Technology",
    "Engineering",
    "Construction",
    "Manufacturing",
    "Healthcare",
    "Production",
    "Automation & Controls",
    "Finance & Accounting",
    "Fintech",
    "Banking",
    "E-Commerce",
    "Supply Chain Management",
    "Science & Innovation",
    "Hospitality",
    "Food & Drink",
    "Real Estate",
    "Energy",
    "Sales",
    "Retail",
    'Trading &  Stocks',
    "Oil & Gas",
    "Logistics",
    "Aerospace",
    "Mining",
    "Pharmaceuticals",
    "Agriculture",
    "Insurance",
    "Gaming",
    "Travel & Tourism",
    "Educational",
    "Edtech",
    "Telecommunication",
    "Gov",
    "Defense",
    "Media & Entertainment",
    "Marketing",
    "Advertising",
    "Others"
  ]

  const optionsDate = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // timeZone: 'UTC'
  };

  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    // timeZone: 'UTC'
  };

  const [subStatus, setSubStatus] = useState('');
  const [statusNote1, setStatusNote1] = useState('')
  
    const [levelM, setLevelM] = useState(false);
    
  const [statusModal, setStatusModal] = useState(false)
    const [data, setData] = useState()
    const openStatusModal = (item) => {
      setData(item)
      setStatusModal(true)
    }
  
    const closeStatusModal = () => {
      setStatusModal(false)
    }
  
    const [loadingStatus, setLoadingStatus] = useState(false)
  
    const Submitted = async () => {
      // console.log("row===>>>>", row)
      setLoadingStatus(true)
      const token = localStorage.getItem('token');
      const body = {
        submissionId: data?._id,
        resumeId: data?.resumeId,
        tempSubmitStatus: subStatus,
        note: `Marked ${subStatus} ${statusNote}`,
        // stepWiseStatus: subStatus,
        jobId : data?.type === "position" ? data?.jobId:"",
        clientName:data?.type === "client" ? data?.clientName :''
      };

      Api(`resume/update_sub_status`, 'POST', body, token)
        .then((response) => {
          // console.log('==========update_any_step=====>>>', response);
          if (response.status === 200) {
            if (response.data.code === 200) {
              setLoadingStatus(true)
              // setLevelM(false);
              toast.success(response.data.message);
              // console.log(row);
              // fun2();
              setStatusNote1('')
              setSubStatus('')
              statusJobs("submitted", data) 
              closeStatusModal()
             
            } else {
              toast.warn(response.data.message);
              setLoadingStatus(false)
            }
          }
          setLoadingStatus(false)
        })
        .catch((err) => { });
    }; 
  
      const getDetails = (id) => {
        const body = {
          "resumeId":id
        }
        const token = localStorage.getItem("token")
        Api(`resume/getResumeDetail`, 'POST', body, token)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.status === 200) {
                // console.log("ashishg---------------->>>>>", response)
                // setPer(response.data);
                // console.log("response.data?.result", response.data?.result)
                navigate('/resumeDetail', {
                  state: {
                    row: response.data?.result,
                    // row: {
                      
                    //   _id: item.resumeId,
                    //   resumeId: item.resumeId,
                    //   // fullName: row.fullName,
                    //   resumeUrl: "",
                    // },
                    // resumeId: item.resumeId,
                   
                //     resumeId:  {
                // _id: item.resumeId,
                //     resumeId: item.resumeId,
                //     },
                    fTab: 'submitted',
                    mtab: 'Resume',
                  },
                });
              } else {
                toast.warn(response.data.message, +'!');
              }
            }
          })
          .catch((err) => {
            // console.log('===========', err);
            toast.error(err, +'!');
          });
      }

      const styleSkillsetDown = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: { xs: '40%', sm: '55%' },
        bgcolor: 'background.paper',
        border: '3px solid #3C6BA5',
        boxShadow: 24,
        p: 3,
        //     paddingTop:3,
        // paddingBottom:3,
        borderRadius: 3,
      };

      const [Values, setValues] = useState({
         
          fromDate: "",
          tillDate: "",
         
        });
      
        const [down, setDown] = useState()
        const [openDown, setOpenDown] = useState(false);
      const [excelStatus, setExcelStatus] = useState('')
      
        const handleOpenDown = () => {
          // setDown(data)
          setOpenDown(true)
      }
        const handleCloseDown = () => setOpenDown(false);
        
        const download = (row) => {
          const body = {
           "actionStatus":actionStatus1,
           "startDate":Values.fromDate,
           "endDate":Values.tillDate,
           "jobId":'',
           "clientId":row?._id
          }
      
          const token = localStorage.getItem("token")
          // Api(`common/jsonToXlsvJobClient`, 'POST', body, token)
           Api(`common/jsonToXlsvJobClient?jobId=${""}&endDate=${Values.tillDate}&startDate=${Values.fromDate}&actionStatus=${actionStatus1}&clientId=${row?._id}&token=${token}`, 'GET', '', '')
             
            .then((response) => {
      //         window.open(
      //           `${window.location.origin}/common/jsonToXlsvJobClient?jobId=${""}&endDate=${Values.tillDate}&startDate=${Values.fromDate}&actionStatus=${actionStatus1}&clientId=${row?._id}&token=${token}`,
      //           "_blank"
      //         ); 
      //         handleCloseDown()
      //         setValues({...Values,
      //           fromDate: "",
      // tillDate: ""
  
      //         })

                  if (response.status === 200) { 
                    if (response.data.status === 200) {
                      // console.log("muza---------------->>>>>", response)
                      generateExcel(excelStatus, response.data?.result)
                      // console.log("response.data?.result", response.data?.result)
                     
                      handleCloseDown()
                      setValues({...Values,
                        fromDate: "",
              tillDate: ""
            
                      })
          //         const link = document.createElement('a');
          //         link.href = response.data?.result;
          //         const fileDown = actionStatus1 === 'submitted' ? 'submitted.xlsx' : 
          //         actionStatus1 === 'interview' ? 'interview.xlsx' : 
          //         'placement.xlsx';
 
          //  link.download = fileDown;
          //         document.body.appendChild(link);
          //         link.click();
          //         document.body.removeChild(link);
          //         deleteXlsx(response.data?.result)
        
          //                    handleCloseDown()
          //                    setValues({...Values,
          //                     fromDate: "",
          //           tillDate: ""
                
          //                   })
                } else {
                  toast.warn(response.data.message, +'!');
                }
              }
            }) 
            .catch((err) => {
              // console.log('===========', err);
              toast.error(err, +'!');
            });
        }
      
        const generateExcel = async (excelStatus, result) => {
          const workbook = new ExcelJS.Workbook();
          const worksheet = workbook.addWorksheet("Sheet1");
       
          let columns = [];
      
          if (excelStatus === "placement") {
              columns = [
                  { header: "Date", key: "Date", width: 20 },
                  { header: "Role", key: "Role", width: 20 },
                  { header: "Name", key: "Name", width: 30 },
                  { header: "Employment Type", key: "EmploymentType", width: 20 },
                  { header: "Visa | TT", key: "TaxVisa", width: 25 },
                  { header: "Compensation", key: "Compensation", width: 15 },
                  { header: "Start Date", key: "StartDate", width: 15 },
                  { header: "End Date", key: "EndDate", width: 15 },
                  { header: "Status", key: "Status", width: 30 },
                  { header: "Presented By", key: "PresentedBy", width: 20 },
              ];
          } else if (excelStatus === "interview") {
              columns = [
                  { header: "Date", key: "Date", width: 20 },
                  { header: "Role", key: "Role", width: 20 },
                  { header: "Name", key: "Name", width: 30 },
                  { header: "Email", key: "Email", width: 32 },
                  { header: "Mode", key: "Mode", width: 15 },
                  { header: "Location", key: "Location", width: 20 },
                  { header: "Hiring Manager", key: "HiringManager", width: 20 },
                  { header: "Status", key: "Status", width: 30 },
                  { header: "Presented By", key: "PresentedBy", width: 20 },
              ];
          } else if (excelStatus === "submitted") {
              columns = [
                  { header: "Date", key: "Date", width: 20 },
                  { header: "Role", key: "Role", width: 20 },
                  { header: "Name", key: "Name", width: 30 },
                  { header: "Email", key: "Email", width: 32 },
                  { header: "Compensation", key: "Compensation", width: 15 },
                  { header: "Visa | TT", key: "TaxVisa", width: 25 },
                  { header: "Status", key: "Status", width: 30 },
                  { header: "Presented By", key: "PresentedBy", width: 20 },
              ];
          }
      
          worksheet.columns = columns;
      
          const optionsDate = {
              year: "numeric",
              month: "short",
              day: "numeric",
          };
      
          const statusPriority = ["L1", "L2", "L3", "L4", "L5"];
      
          result.forEach((row) => {
              const formattedRow = Object.fromEntries(
                  columns.map(({ key }) => [
                      key,
                      row[key] !== undefined && row[key] !== null && row[key] !== "" ? row[key] : "-",
                  ])
              );
      
              const formatDateTime = (date) =>
                  date
                      ? `${new Date(date)?.toLocaleString("en-US", optionsDate)} ${String(new Date(date)?.getHours())?.padStart(2, "0")}:${String(new Date(date)?.getMinutes())?.padStart(2, "0")}`
                      : "-";
      
              const formatDate = (date) => (date ? new Date(date)?.toLocaleDateString("en-US", optionsDate) : "-");
      
              formattedRow.Date = formatDateTime(row?.createdAt);
              formattedRow.StartDate = formatDate(row?.StartDate);
              formattedRow.EndDate = formatDate(row?.EndDate);
      
              formattedRow.Role = row?.Role
              ? row.Role?.charAt(0)?.toUpperCase() + row.Role?.slice(1)
              : "-";

              if (excelStatus === "placement" || excelStatus === "submitted") {
                  const { VisaType, TaxTerm } = row;
                  formattedRow.TaxVisa = VisaType && TaxTerm ? `${VisaType} | ${TaxTerm}` : VisaType || TaxTerm || "-";
              }
      
              if (statusPriority?.includes(row.Status)) {
                  formattedRow.Status = `${row.Status} Interview`;
              } else {
                  formattedRow.Status = row.Status || "-";
              }
      
              worksheet.addRow(formattedRow);
          });
      
          
          const headerRow = worksheet.getRow(1);
          headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
          headerRow.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FF0000FF" },
          };
          headerRow.alignment = { horizontal: "left" };
      
          
          worksheet.eachRow((row, rowNumber) => {
              row.eachCell((cell) => {
                  cell.alignment = { horizontal: "left" };
              });
          });
      
          const buffer = await workbook.xlsx.writeBuffer();
          const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          saveAs(blob, `${excelStatus}.xlsx`);
      };
            
         const deleteXlsx = (file) => {
                    const body = {
                     "filePath":file,
                    }
                    const token = localStorage.getItem("token")
                    Api(`common/deleteXLXvJobClientFile`, 'POST', body, token)
                      .then((response) => {
                        if (response.status === 200) {
                          if (response.data.status === 200) {
                            // console.log("muza---------------->>>>>", response)
                            // setPer(response.data);
                            // console.log("response.data?.result", response.data?.result)
                           
                          } else {
                            toast.warn(response.data.message, +'!');
                          }
                        }
                      })
                      .catch((err) => {
                        // console.log('===========', err);
                        toast.error(err, +'!');
                      });
                  }

        const handleDateChange = (date, field) => {
          const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
          setValues((prevRec) => ({
            ...prevRec,
            [field]: formattedDate
          }));
          // console.log("formattedDate====>>>>", formattedDate);
        };
      
  return (
    <>
      <TableRow
        key={row._id}
        sx={[
          { background: index % 2 === 0 ? 'text.background' : tablebg },
          { '&:last-child td, &:last-child th': { border: 0 } },
          { '&:hover': { boxShadow: 5 } },
        ]}
      >
        <TableCell sx={{}}>
          <Typography>Std -{" "}
            {/* {moment(row.startDate).format('lll')} */}
            {`${new Date(row.startDate).toLocaleString('en-US', optionsDate)}`}
            {/* ${new Date(row.startDate).toLocaleString('en-US', optionsTime)} */}
          </Typography>
          {/* <Typography>Since {moment().diff(row.createdAt, 'months')} months</Typography> */}
          <Typography>Cr -{" "}
            {/* {moment(row.createdAt).format('lll')} */}
            {`${new Date(row.createdAt).toLocaleString('en-US', optionsDate)}`}
          </Typography>
          <Stack sx={{ flexDirection: 'row', gap: 1 }}>
            {role === 'admin' || role === 'salesHead' || role === "salesManager" || role === "salesTeamLead" || role === "salesExecutive" || role === "salesTrainee" || role === 'recruiterHead' || role === 'recruiterManager' ? (
              <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }} onClick={() => editOpen()}>
                Edit
              </Typography>
            ) : (
              <Typography>&nbsp;</Typography>
            )}
            <Stack sx={{ flexDirection: 'row' }} onClick={() => openActivity()}>
              <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
              <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>

                {row.notes?.length ? `+${row.notes?.length}` : ''}
              </Typography>
            </Stack>
          </Stack>
        </TableCell>

        <TableCell sx={{}}>
          <Stack flexDirection={'row'} alignItems={'center'}>
            <Typography
              sx={{
                fontSize: '0.90rem',
                color: (row.status === "On Hold" || row.status === "Inactive") ? "red" : 'text.secondary',
                fontWeight: '600',
                cursor: 'pointer',
                maxWidth: 160,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              onClick={() => navigate('/clientLeads', { state: row })}
            >
              {row.companyName || '-'}
            </Typography>
            <Iconify
              icon="mdi:web"
              color={'text.secondary'}
              sx={{ m: 0.3, height: 15, width: 15, cursor: 'pointer' }}
              onClick={() => window.open(row.websiteUrl, '_blank', 'noopener', 'noreferrer')}
            />
          </Stack>
          <Typography
            onClick={() => navigate('/clientDetail', { state: { row } })}
            sx={{ cursor: 'pointer', color: 'text.secondary' }}
          >
            {' '}
            Details{' '}
          </Typography>
          <Typography sx={{ color: 'text.textG', width: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {row.location || '-'}
          </Typography>
        </TableCell>

        <TableCell sx={{}}>
          <Stack flexDirection={'row'} alignItems={'center'}>
            <Typography
              sx={{
                fontWeight: 600,
                color: 'text.secondary',
                maxWidth: 160,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {row.contactPersonName || '-'}
            </Typography>
            <Iconify
              icon="devicon:linkedin"
              color={'text.textG'}
              sx={{ m: 0.3, height: 15, width: 15, cursor: 'pointer' }}
              onClick={() => window.open(row.linkedinUrl, '_blank')}
            />
          </Stack>
          <Typography sx={{ textTransform: 'none', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {row.email || '-'}
          </Typography>
          <Typography sx={{ color: 'text.textG' }}>
            {/* {row.contactNoWithISD || '-'} */}
            {/* {row.contactNoWithISD?.replace(/(\d{3})(?=\d)/g, '$1 ').trim() ? row.contactNoWithISD?.replace(/(\d{3})(?=\d)/g, '$1 ').trim() : "-"} */}
            {
              row?.contactNoWithISD?.trim()
                ? row?.contactNoWithISD?.trim()
                  ?.replace(/\s+/g, '')
                  ?.replace(/^(\+?\d{1,3})?(\d{10,20})$/, (match, p1, p2) => {
                    if (p1) {
                      const countryCode = p1;
                      const lastDigits = p2?.slice(-10);
                      return `${countryCode} ${lastDigits?.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3')}`;
                    }
                    return p2?.replace(/(\d{3})(\d{3})(\d{4})(\d{3,4})?/, '$1 $2 $3 $4')?.trim();
                  })
                : '-'
            }
          </Typography>
        </TableCell>

        <TableCell sx={{}}>
          <Stack flexDirection={'row'} gap={1} alignItems={'center'}>
            <Typography sx={{ fontWeight: 600, color: 'text.secondary' }}>{row.clientCompanyId}</Typography>
          </Stack>
          <Typography>{row.RPO_Staffing || '-'}</Typography>
          <Typography sx={{ color: 'text.textG', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {row.domain || '-'}
          </Typography>
        </TableCell>

        <TableCell sx={{}}>
          <Typography sx={{ fontWeight: '600', cursor: 'pointer' }} onClick={openTotalJob}>
            Total Jobs : {row.totalJobs}
          </Typography>
          <Typography sx={{ color: '#4BB03B', fontWeight: '600', cursor: 'pointer' }} onClick={openJob}>
            Open Jobs : {row.openJobs}
          </Typography>
          <Typography
            sx={{ color: 'text.secondary', fontWeight: '600', cursor: 'pointer' }}
            onClick={() =>
              navigate('/addjob', {
                state: {
                  rowData: {
                    companyName: row.companyName,
                    client: row.contactPersonName,
                    _id: row._id,
                    email: row.email,
                    web: row.websiteUrl,
                  },
                },
              })
            }
          >
            Add Job
          </Typography>
        </TableCell>

        <TableCell sx={{ color: 'text.secondary', fontWeight: '600', cursor: 'pointer' }}>
          {/* <Stack sx={{ flexDirection: 'row' }} 
        // onClick={(e) => getClients()}
        onClick={handleOpenn}
        >
                <Iconify icon="tabler:activity" fontSize={20} color={'text.secondary'} />
                <Typography sx={{ color: 'text.secondary', cursor: 'pointer' }}>
                  
                  {row?.clients ? `+ ${row?.clients}` : ''}
                </Typography>
              </Stack> */}
          <Typography sx={{ fontWeight: '600', cursor: 'pointer' }} onClick={openSub}>
            Submissions : {row.submittedCount}
          </Typography>
          <Typography sx={{ color: '#AE8D18', fontWeight: '600', cursor: 'pointer' }} onClick={openInterview}>
            Interviews : {row.interviewCount}
          </Typography>
          <Typography sx={{ color: '#399648', fontWeight: '600', cursor: 'pointer' }} onClick={openPlacement}>
            Placements : {row.placementCount}
          </Typography>
        </TableCell>

        <TableCell sx={{}}>
          <Stack sx={{ flexDirection: 'row' }}>
            <Typography sx={{}}>{row.status || 'Status'}</Typography>
            {role === 'admin' || role === 'salesHead' || role === 'recruiterHead' || role === 'recruiterManager' ? (
              <Iconify
                icon="bx:edit"
                // color={'text.textB'}
                sx={{ height: 15, width: 15, cursor: 'pointer' }}
                onClick={() => statusOpen()}
              />
            ) : null}
          </Stack>
          <Stack sx={{ flexDirection: 'row', cursor: 'pointer' }}>
            <Typography
              sx={{ color: '#4671A1' }}
              onClick={() => {
                clientUser();
              }}
            >
              Assignees
            </Typography>
            {role === 'admin' || role === 'salesHead' || role === 'recruiterHead' || role === 'recruiterManager' ? (
              <Iconify
                icon="bx:edit"
                // color={'text.textB'}
                sx={{ height: 15, width: 15 }}
                onClick={() => {
                  getAllUser();
                  assOpen();
                }}
              />
            ) : null}
          </Stack>
          {/* <Typography onClick={openActivity} sx={{color:'text.secondary',cursor: 'pointer'}}>{row.designation}</Typography> */}
          {/* <Typography sx={{ color: 'text.textG' }}>{row.salesPerson || row.addedBy || '-'}</Typography> */}
          <Typography sx={{ color: 'text.textG' }}>{row.addedBy || '-'}</Typography>
        </TableCell>

        <TableCell sx={{}}>
          <Typography sx={{ color: 'text.secondary' }}>Invoice</Typography>
          <Typography>{row.amountType || '-'}</Typography>
          {row.amountType === 'Percentage Basis' ? (
            <Typography sx={{ color: 'text.textG' }}>{row.amountValue || '-'} %</Typography>
          ) : row.amountType === 'Subscription' ? (
            <Typography sx={{ color: 'text.textG' }}>
              ${row.amountValue || '-'}/{row.subPlan}
            </Typography>
          ) : row.amountType === 'Margin Basis' ? (
            <Typography sx={{ color: 'text.textG' }}>${row.amountValue || '-'} P/H</Typography>
          ) : (
            <Typography sx={{ color: 'text.textG' }}>${row.amountValue || '-'} K</Typography>
          )}
        </TableCell>
      </TableRow>

        {/* <Modal open={levelM} onClose={() => setLevelM(false)} style={{ borderRadius: 10 }}> */}
          <Modal open={statusModal} onClose={closeStatusModal} style={{ borderRadius: 10 }}>
              <Box sx={[styleSkillset, { width: { xs: '60%', sm: '50%' } }]}>
                <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
                  Change Status
                </Typography>
                <Divider />
                <Stack sx={{ justifyContent: 'center', gap: 2, mb: 2, mt: 2, width: '100%' }}>
                  <Stack sx={{ alignSelf: 'center', gap: 3, width: '60%' }}>
                    <FormControl>
                      <InputLabel id="demo-simple-select-label">Select New Status</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        InputLabelProps={{ shrink: true }}
                        label="Select New Status"
                        placeholder="Select New Status"
                        value={subStatus}
                        onChange={(e) => setSubStatus(e.target.value)}
                      >
                        <MenuItem value={'client Submission'}>Client Submission</MenuItem>
                        <MenuItem value={'unqualified'}>Unqualified</MenuItem>
                        <MenuItem value={'shortlisted'}>Shortlisted</MenuItem>
                        <MenuItem value={'job On Hold'}>Job On Hold</MenuItem>
                        <MenuItem value={'out Of Market'}>Out of Market</MenuItem>
                        <MenuItem value={'Duplicate Submission'}>Duplicate Submission</MenuItem>
                      </Select>
                    </FormControl>
      
                    <FormControl sx={{}}>
                      <TextField
                        id="outlined-multiline-static"
                        label="Note... (Max 2000 char)"
                        placeholder="Note..."
                        multiline
                        rows={5}
                        value={statusNote1}
                        onChange={(e) => setStatusNote1(e.target.value)}
                      />
                    </FormControl>
                    <Button
                      color="custom"
                      variant="contained"
                      sx={{ width: '15%', alignSelf: 'center' }}
                      disabled={loadingStatus}
                      onClick={(e) => Submitted(row)}
                    >
                     
                      {loadingStatus ? <CircularProgress size={21} /> : 'Submit'}
                    </Button>
                  </Stack>
                </Stack>
              </Box>
            </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="h4" textAlign={'center'} color={'text.secondary'}>
            Email Box
          </Typography>
          <Scrollbar sx={{ height: { sm: 500, xs: 500 } }}>
            <Grid display={'grid'} gap={2}>
              <TextField
                id="outlined-basic"
                label="Subject"
                placeholder="Subject"
                variant="outlined"
                value={email?.Subject}
                onChange={(e) => setEmail({ ...email, Subject: e.target.value })}
              />
              <ReactQuill
                modules={modules}
                theme="snow"
                value={smsValue}
                onChange={(e) => setEditorSmsValue(e)}
                style={{ height: '80%', display: 'block' }}
              />
            </Grid>
          </Scrollbar>
          <Button onClick={() => console.log(email)}>test</Button>
        </Box>
      </Modal>
      {/* <Modal open={openD} onClose={closeDetail} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients,{height:'90%'}]}>
          <Typography variant="h6" sx={{ textAlign: 'center', color: 'text.secondary' }}>
            Detail
          </Typography>
          <Scrollbar sx={{ maxHeight: 450, Scrollbar: 'thin' }}>
            <Divider />
            <Stack sx={{ p: 2, py: 4, mx: 4, flexDirection: 'row' }}>
              <Stack sx={{ p: 1, width: '50%' }}>
                <iframe title="resume" src={suru +contractUrl+ lll} width="100%" height="650px" />
              </Stack>
              <Stack sx={{ p: 1, width: '50%' }}>
              <Stack sx={{ flexDirection: 'row', gap: 2, mb: 2, cursor: 'pointer' }}>
            <Stack
              sx={[
                { flexDirection: 'row' },
                tabs === 'Agreement' ? { borderBottom: 2, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                setTabs('Agreement');
              }}
            >
              <Iconify icon="bi:filetype-pdf" sx={{ mb: 0.5 }} fontSize={20} />
              <Typography  sx={{ ml: 0.5, mb: 0.5,fontSize:'0.9rem',fontWeight:'600' }}>
                Agreement
              </Typography>
            </Stack>
            <Stack
              sx={[
                { flexDirection: 'row' },
                tabs === 'Detail' ? { borderBottom: 2, color: 'text.secondary' } : { color: 'text.textG' },
              ]}
              onClick={() => {
                setTabs('Detail');
              }}
            >
              <Iconify icon="mingcute:user-4-fill" sx={{ mb: 0.5 }} fontSize={20} />
              <Typography  sx={{ ml: 0.5, mb: 0.5,fontSize:'0.9rem',fontWeight:'600' }} onClick={()=> navigate('/clientDetail', { state: { row } })}>
                Detail
              </Typography>
            </Stack>
            </Stack>
                 {tabs === 'Agreement' ? (
                  <Stack sx={{ backgroundColor: 'text.background', borderRadius: 2, boxShadow: 3, p: 2, gap: 2 }}>
                    <Stack sx={{ flexDirection: 'row', gap: 1 }}>
                      <Stack>
                        <Button
                          type="file"
                          variant="contained"
                          size="small"
                          color="custom"
                          sx={{ width: 'fit-content' }}
                          // onClick={(e) => updateNote()}
                        >
                          Add New Agreement
                        </Button>
                        <input
                          style={{ opacity: 0, position: 'absolute', width: 120 }}
                          type="file"
                          accept=".doc,.docx, application/pdf"
                          onChange={(e) => {
                            pdfUpload(e.target.files[0]);
                          }}
                        />
                      </Stack>
                      {upload && <Typography sx={{ color: 'text.secondary', p: 0.5 }}>Success</Typography>}
                    </Stack>
                    <Scrollbar sx={{ maxHeight: 300, Scrollbar: 'thin' }}>
                      {resumeArry.length ? resumeArry.map((item,index)=>{
                       return <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                      <Stack sx={{flexDirection:'row'}}> 
                      <Typography
                        color={'text.secondary'}
                        sx={{ textDecoration: 'underline',cursor: 'pointer'  }}
                        onClick={() => setContractUrl(item.contractUrl)}
                      >
                        Agreement #{index+1}
                      </Typography>
                      <Iconify
                        icon="mdi:open-in-new"
                        fontSize={20}
                        sx={{ cursor: 'pointer',ml:3 }}
                        onClick={() => window.open(suru+item.contractUrl+lll, '_blank')}
                        color={'text.secondary'}
                      />
                      </Stack>
                      <Typography sx={{}}>Uploaded on : {moment(item.createdAt).format('ll')}</Typography>
                      
                      <Stack sx={{flexDirection:'row'}}>
                      <Typography color={'text.secondary'} sx={{ cursor: 'pointer' }} onClick={()=>deleteContract(item._id)}>
                        Delete
                      </Typography>
                      <Typography
                        color={'text.secondary'}
                        sx={{ cursor: 'pointer',ml:3}}
                        onClick={() => window.open(item.contractUrl, '_blank')}
                      >
                        Download
                      </Typography>
                      </Stack>
                    </Stack>
                    }):null}
                    </Scrollbar>
                    <TextField
                  sx={{ mt: 2 }}
                  id="outlined-multiline-static"
                  label="Note... (Max 2000 char)"
                  placeholder="Note..."
                  multiline
                  rows={5}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
                <Button
                  variant="contained"
                  size="small"
                  color="custom"
                  sx={{ width: 'fit-content', height: 30, mt: 2 }}
                  //   onClick={() => openScreening()}
                >
                  Save
                </Button>
                  </Stack>
                ) : null}
              
              </Stack>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

       <Modal open={openDown} onClose={handleCloseDown} style={{ borderRadius: 10 }}>
              <Box sx={[styleSkillsetDown]}>
                {/* <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
                  Set Priority
                </Typography> */}
      
                <Divider/>
                <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
                <Grid container sx={{ flexDirection: "row", mt:0.6 }} spacing={2}>
                    <Grid item xs={6} sx={{  }}>
                      <FormControl fullWidth size="small">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="From"
                            slotProps={{ textField: {} }}
                            value={Values.fromDate ? dayjs(Values.fromDate) : null}
                           
                            onChange={(date) => handleDateChange(date, 'fromDate')}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sx={{  }}>
                      <FormControl fullWidth size="small">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="Till"
                            slotProps={{ textField: { } }}
                            value={Values.tillDate ? dayjs(Values.tillDate) : null}
                          
                            onChange={(date) => handleDateChange(date, 'tillDate')}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Button color="custom" variant="contained" sx={{ width: '12%', mt: 2.6 }} 
                    disabled={!(Values.tillDate && Values.fromDate)}
                    onClick={()=>download(row)}>
                     Download
                    </Button>
                  </Stack>
                </Scrollbar>
              </Box>
            </Modal>

      {/* <Modal open={openA} onClose={closeActivity} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Activities
          </Typography>
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Divider />
            <Stack sx={{ alignItems: 'center' }}>
              <Stack
                sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
              >
                <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography sx={{ width: '18%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Date
                  </Typography>
                  <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    User Name
                  </Typography>
                  <Typography sx={{ width: '15%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Status
                  </Typography>
                  <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Note
                  </Typography>
                </Stack>
              </Stack>
              {row.notes?.length
                ? row.notes
                  ?.slice(0)
                  ?.reverse()
                  ?.map((item, index) => {
                    return (
                      <Stack
                        sx={[
                          { background: index % 2 === 0 ? 'text.background' : tablebg },
                          { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                        ]}
                      >
                        <Typography sx={{ width: '18%' }}>
                          
                          {item.date ?
                            `${new Date(item?.date).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.date)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.date)?.getMinutes())?.padStart(2, '0')}`
                            : "-"
                          }
                        </Typography>
                        <Typography
                          sx={{
                            width: '20%',
                            textTransform: 'capitalize',
                            fontWeight: '600',
                            color: 'text.secondary',
                          }}
                        >
                          {item.noteBy}
                        </Typography>
                        <Typography sx={{ width: '15%', textTransform: 'capitalize' }}>
                        
                          {item.status}
                        </Typography>
                        <Typography sx={{ width: '50%', textTransform: 'capitalize' }}>{item.note}</Typography>
                      </Stack>
                    );
                  })
                : null}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

<Modal open={openA} onClose={closeActivity} style={{ borderRadius: 10 }}>
  <Box sx={styleClients}>
    <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
      Activities
    </Typography>
    <Scrollbar sx={{ maxHeight: 400 }}>
      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ minWidth: '700px' }}>
          <Divider />
          <Stack sx={{ alignItems: 'center' }}>
            <Stack
              sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
            >
              <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography sx={{ width: '18%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                  Date
                </Typography>
                <Typography sx={{ width: '20%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                  User Name
                </Typography>
                <Typography sx={{ width: '15%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                  Status
                </Typography>
                <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                  Note
                </Typography>
              </Stack>
            </Stack>
            {row.notes?.length
              ? row.notes
                  .slice(0)
                  .reverse()
                  .map((item, index) => (
                    <Stack
                      key={index}
                      sx={{
                        background: index % 2 === 0 ? 'text.background' : tablebg,
                        width: '100%',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        p: 1,
                      }}
                    >
                      <Typography sx={{ width: '18%' }}>
                        {item.date
                          ? `${new Date(item?.date).toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.date)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.date)?.getMinutes())?.padStart(2, '0')}`
                          : '-'}
                      </Typography>
                      <Typography
                        sx={{
                          width: '20%',
                          textTransform: 'capitalize',
                          fontWeight: '600',
                          color: 'text.secondary',
                        }}
                      >
                        {item.noteBy}
                      </Typography>
                      <Typography sx={{ width: '15%', textTransform: 'capitalize' }}>{item.status}</Typography>
                      <Typography sx={{ width: '50%', textTransform: 'capitalize' }}>{item.note}</Typography>
                    </Stack>
                  ))
              : null}
          </Stack>
        </Box>
      </Box>
    </Scrollbar>
  </Box>
</Modal>

      <Modal open={openC} onClose={closeCandidateDetails} style={{ borderRadius: 10 }}>
        <Box sx={styleClients}>
          {/* <Typography variant="h5" color={'#3C6BA5'}>
            Client's Leads
          </Typography> */}

          <Stack flexDirection={'row'} justifyContent={'space-between'}>
            <Typography variant="h5" color={'text.secondary'}>
              Client's Leads
            </Typography>
            <Button variant="contained">Add Lead</Button>
          </Stack>

          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Divider />
            <Stack sx={{ alignItems: 'center' }}>
              <Stack
                sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
              >
                <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Date</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Name</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Designation</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Phone</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Email</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Jobs</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Open Jobs</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Placements</Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>Status</Typography>
                </Stack>
              </Stack>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      {/* <Modal open={openT} onClose={closeTotalJob} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '60%', sm: '90%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Total Jobs
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{ alignItems: 'center' }}>
              <Stack
                sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
              >
                <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '11%' }}>
                    Date
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                    Role
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                    Location
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Job Type
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Submission
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Interview
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Placement
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Lead
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Status
                  </Typography>
                </Stack>
              </Stack>
              {totalData.length
                ? totalData.map((item, index) => {
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { width: '100%', p: 0.5, flexDirection: 'row', justifyContent: 'space-between' },
                      ]}
                    >
                      <Typography sx={{ width: '10%' }}>
                      
                        {`${new Date(item.createdAT).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAT).getHours()).padStart(2, '0')}:${String(new Date(item?.createdAT).getMinutes()).padStart(2, '0')}`}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'text.secondary',
                          width: '15%',
                          fontSize: '0.90rem',
                          fontWeight: '600',
                          overflow: 'auto',  
                          whiteSpace: 'nowrap',
                          maxWidth: 155, 
                          ml:1.6
                          
                        }} 
                      >
                        {item.jobTitle || '-'}
                      </Typography>
                      <Typography sx={{ width: '15%', overflow: 'auto', whiteSpace: 'nowrap', ml:2 }}>
                        {item.location || '-'}
                      </Typography>
                      <Typography sx={{ width: '10%', textTransform: 'capitalize' }}>
                        {item.jobType || '-'}
                      </Typography>
                      <Typography sx={{ width: '10%' }}>{item.submittedCount}</Typography>
                      <Typography sx={{ width: '10%' }}>{item.interviewCount}</Typography>
                      <Typography sx={{ width: '10%' }}>{item.placementCount}</Typography>
                      <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap' }}>
                        {item.lead || '-'}
                      </Typography>
                      <Stack sx={{ width: '10%', flexDirection: 'row' }}>
                        <Typography>{item.status || '-'}</Typography>
                        <Iconify
                          icon="bx:edit"
                          
                          sx={{ height: 18, width: 18, ml: 1 }}
                          onClick={() => {
                            localStorage.setItem('tempJobId', item._id);
                            jobStatusOpen();
                          }}
                        />
                      </Stack>
                    </Stack>
                  );
                })
                : null}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

<Modal open={openT} onClose={closeTotalJob} style={{ borderRadius: 10 }}>
  <Box sx={[styleClients, { width: { xs: '90%', sm: '90%' } }]}>
    <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
      Total Jobs
    </Typography>
    <Divider sx={{ mb: 2 }} /> 
    <Scrollbar sx={{ maxHeight: 400 }}>
      <Box sx={{ minWidth: '950px', overflowX: 'auto' }}>
        <Stack sx={{ alignItems: 'center' }}>
       
          <Stack
            sx={{
              backgroundColor: 'text.secondary',
              width: '100%',
              alignItems: 'center',
              p: 0.5,
              borderRadius: 1,
            }}
          >
            <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '12%' }}>
                Date
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                Role
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                Location
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Job Type
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Submission
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Interview
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Placement
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Lead
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Status
              </Typography>
            </Stack>
          </Stack>

          {totalData.length
            ? totalData.map((item, index) => (
                <Stack
                  key={index}
                  sx={{
                    background: index % 2 === 0 ? 'text.background' : tablebg,
                    width: '100%',
                    p: 0.5,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography sx={{ width: '11%' }}>
                    {`${new Date(item.createdAT)?.toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAT)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAT)?.getMinutes())?.padStart(2, '0')}`}
                  </Typography>
                  <Typography
                    sx={{
                      color: 'text.secondary',
                      width: '15%',
                      fontSize: '0.90rem',
                      fontWeight: '600',
                      overflow: 'auto',
                      whiteSpace: 'nowrap',
                      maxWidth: 155,
                      ml: 1.6,
                    }}
                  >
                    {item.jobTitle || '-'}
                  </Typography>
                  <Typography sx={{ width: '15%', overflow: 'auto', whiteSpace: 'nowrap', ml: 2 }}>
                    {item.location || '-'}
                  </Typography>
                  <Typography sx={{ width: '10%', textTransform: 'capitalize' }}>
                    {item.jobType || '-'}
                  </Typography>
                  <Typography sx={{ width: '10%' }}>{item.submittedCount}</Typography>
                  <Typography sx={{ width: '10%' }}>{item.interviewCount}</Typography>
                  <Typography sx={{ width: '10%' }}>{item.placementCount}</Typography>
                  <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap' }}>
                    {item.lead || '-'}
                  </Typography>
                  <Stack sx={{ width: '10%', flexDirection: 'row' }}>
                    <Typography>{item.status || '-'}</Typography>
                    <Iconify
                      icon="bx:edit"
                      sx={{ height: 18, width: 18, ml: 1 }}
                      onClick={() => {
                        localStorage.setItem('tempJobId', item._id);
                        jobStatusOpen();
                      }}
                    />
                  </Stack>
                </Stack>
              ))
            : null}
        </Stack>
      </Box>
    </Scrollbar>
  </Box>
</Modal>

      <Modal open={openn} onClose={handleClosen} style={{ borderRadius: 10 }}>
        <Box sx={[styleSkillset, { width: '70%' }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Activities
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 600, Scrollbar: 'thin' }}>
            <Stack sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}>
              <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography sx={{ width: '15%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  Date
                </Typography>
                <Typography sx={{ width: '15%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  User
                </Typography>
                <Typography sx={{ width: '25%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  Status
                </Typography>
                <Typography sx={{ width: '55%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }} color={'text.secondary'}>
                  Note
                </Typography>
              </Stack>
            </Stack>
            {row?.notes?.length &&
              row?.notes?.slice(0)?.reverse()?.map((item, index) => {
                // row?.notes?.map((item, index) => {
                return (
                  <Stack
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                    ]}
                  >
                    <Typography sx={{ width: '15%' }}>
                      {/* {moment(`${item?.createdAt}`).format('lll')} */}
                      {/* {`${new Date(item?.createdAt).toLocaleString('en-US', optionsDate)} 
 ${new Date(item?.createdAt).getHours()}`}:{`${new Date(item?.createdAt).getMinutes()}`} */}

                      {item.createdAt ?
                        `${new Date(item?.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt).getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`
                        : "-"
                      }
                    </Typography>
                    <Typography sx={{ width: '15%', color: 'text.secondary', textTransform: 'capitalize', fontWeight: '600' }}>{item.noteBy}</Typography>
                    {item.status === 'dnc' ? (
                      <Typography sx={{ width: '25%' }}>DNC</Typography>
                    ) : ''}
                    {item.status === 'passiveclient' ? (
                      <Typography sx={{ width: '25%' }}>Passive Client</Typography>
                    ) : ''}
                    {item.status !== 'dnc' && item.status !== 'passiveclient' ? (
                      <Typography sx={{ width: '25%' }}>{item.status}</Typography>
                    ) : ''}
                    <Typography sx={{ width: '55%', textTransform: 'capitalize' }}>
                      {/* <div dangerouslySetInnerHTML={{ __html: item.note }}/>
                       */}

                      {item.note}
                    </Typography>
                  </Stack>
                );
              })}
          </Scrollbar> 
        </Box>         
      </Modal>

      {/* <Modal open={openJ} onClose={closeJob} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '60%', sm: '95%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Open Jobs
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{ alignItems: 'center' }}>
              <Stack
                sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
              >
                <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '11%' }}>
                    Date
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                    Role
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                    Location
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Job Type
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Submission
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Interview
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Placement
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Lead
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                    Status
                  </Typography>
                </Stack>
              </Stack>
              {openData.length
                ? openData.map((item, index) => {
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { width: '100%', p: 0.5, flexDirection: 'row', justifyContent: 'space-between' },
                      ]}
                    >
                      <Typography sx={{ width: '10%' }}>
                       
                        {`${new Date(item.createdAT)?.toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAT)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAT)?.getMinutes())?.padStart(2, '0')}`}
                      </Typography>
                      <Typography
                        sx={{
                          color: 'text.secondary',
                          width: '15%',
                          maxWidth: 160, 
                          
                          overflow: 'auto',
                          whiteSpace: 'nowrap',
                          fontWeight: '600',
                          fontSize: '0.90rem',
                          ml:0.6
                        }}
                      >
                        {item.jobTitle || '-'}
                        
                      </Typography>
                      <Typography sx={{ width: '15%', overflow: 'auto', whiteSpace: 'nowrap', ml:2 }}>
                        {item.location || '-'}
                      </Typography>
                      <Typography sx={{ width: '10%', textTransform: 'capitalize' }}>
                        {item.jobType || '-'}
                      </Typography>
                      <Typography sx={{ width: '10%' }}>{item.submittedCount}</Typography>
                      <Typography sx={{ width: '10%' }}>{item.interviewCount}</Typography>
                      <Typography sx={{ width: '10%' }}>{item.placementCount}</Typography>
                      <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap' }}>
                        {item.lead || '-'}
                      </Typography>
                      <Stack sx={{ width: '10%', flexDirection: 'row' }}>
                        <Typography>{item.status || '-'}</Typography>
                        <Iconify
                          icon="bx:edit"
                        
                          sx={{ height: 18, width: 18, ml: 1 }}
                          onClick={() => {
                            localStorage.setItem('tempJobId', item._id);
                            jobStatusOpen();
                          }}
                        />
                      </Stack>
                    </Stack>
                  );
                })
                : null}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

<Modal open={openJ} onClose={closeJob} style={{ borderRadius: 10 }}>
  <Box sx={[styleClients, { width: { xs: '95%', sm: '90%' } }]}>
    <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
      Open Jobs
    </Typography>
    <Divider sx={{ mb: 2 }} />
    <Scrollbar sx={{ maxHeight: 400 }}>
      <Box sx={{ minWidth: '950px', overflowX: 'auto' }}>
        <Stack sx={{ alignItems: 'center' }}>
          
          <Stack
            sx={{
              backgroundColor: 'text.secondary',
              width: '100%',
              alignItems: 'center',
              p: 0.5,
              borderRadius: 1,
            }}
          >
            <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '11%' }}>
                Date
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                Role
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '15%' }}>
                Location
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Job Type
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Submission
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Interview
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Placement
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Lead
              </Typography>
              <Typography sx={{ color: 'white', fontSize: '0.976rem', fontWeight: '600', width: '10%' }}>
                Status
              </Typography>
            </Stack>
          </Stack>

          {openData.length
            ? openData.map((item, index) => (
                <Stack
                  key={index}
                  sx={{
                    background: index % 2 === 0 ? 'text.background' : tablebg,
                    width: '100%',
                    p: 0.5,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <Typography sx={{ width: '11%' }}>
                    {`${new Date(item.createdAT)?.toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAT)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAT)?.getMinutes())?.padStart(2, '0')}`}
                  </Typography>
                  <Typography
                    sx={{
                      color: 'text.secondary',
                      width: '15%',
                      maxWidth: 160,
                      overflow: 'auto',
                      whiteSpace: 'nowrap',
                      fontWeight: '600',
                      fontSize: '0.90rem',
                      ml: 0.6,
                    }}
                  >
                    {item.jobTitle || '-'}
                  </Typography>
                  <Typography sx={{ width: '15%', overflow: 'auto', whiteSpace: 'nowrap', ml: 2 }}>
                    {item.location || '-'}
                  </Typography>
                  <Typography sx={{ width: '10%', textTransform: 'capitalize' }}>
                    {item.jobType || '-'}
                  </Typography>
                  <Typography sx={{ width: '10%' }}>{item.submittedCount}</Typography>
                  <Typography sx={{ width: '10%' }}>{item.interviewCount}</Typography>
                  <Typography sx={{ width: '10%' }}>{item.placementCount}</Typography>
                  <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap' }}>
                    {item.lead || '-'}
                  </Typography>
                  <Stack sx={{ width: '10%', flexDirection: 'row' }}>
                    <Typography>{item.status || '-'}</Typography>
                    <Iconify
                      icon="bx:edit"
                      sx={{ height: 18, width: 18, ml: 1 }}
                      onClick={() => {
                        localStorage.setItem('tempJobId', item._id);
                        jobStatusOpen();
                      }}
                    />
                  </Stack>
                </Stack>
              ))
            : null}
        </Stack>
      </Box>
    </Scrollbar>
  </Box>
</Modal>

      {/* <Modal open={openS} onClose={closeSubmission} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '60%', sm: '95%' } }]}>
          
           <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        justifyContent: { xs: "center", sm: "space-between" },
                        width: "100%",
                        position: "relative",
                        textAlign: "center",
                      }}
                    >
          
                      <Typography
                        variant="h5"
                        color="#3C6BA5"
                        sx={{
                          position: { sm: "absolute" },
                          left: { sm: "50%" },
                          transform: { sm: "translateX(-50%)" },
                          mb: { xs: 1, sm: 0 },
                        }}
                      >
                        Submissions
                      </Typography>
          
                      <Stack
                        direction="row"
                        spacing={1.9}
                        sx={{
                          display: "flex",
                          justifyContent: { xs: "center", sm: "flex-end" },
                          width: { xs: "100%", sm: "auto" },
                          ml: "auto",
                        }}
                      >
                        <Button color="custom" variant="contained" onClick={()=>handleOpenDown()}>Export</Button>
                        
                      </Stack>
                    </Box>
          
                    <Divider sx={{ mb: 2, mt:1 }} /> 
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{ alignItems: 'center' }}>
              <Stack
                sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
              >
                <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12%' }}>
                    Date
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '15%' }}>
                    End Client Name
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '16%' }}>
                    Role
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '16%' }}>
                    Name
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13.5%' }}>
                    Email
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '8%' }}>
                    Pay
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>
                    Visa | TT
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '14%' }}>
                    Status
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>
                    Presented By
                  </Typography>
                </Stack>
              </Stack>
              {tempData.length
                ? tempData.map((item, index) => {
                 
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { width: '100%', p: 0.5, flexDirection: 'row', justifyContent: 'space-between',
                          
                         },
                        
                      ]} 
                    >
                      <Typography sx={{ width: '12%', fontSize: '0.7rem' }}>
                        
                        {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                      </Typography>
                    
 <Typography sx={{ width: '15%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                  {item.submissionData?.endClientName|| '-'}
                </Typography>

                      <Typography
                        sx={{ 
                          
                          width: '15%',
                          overflow: 'auto',
                          whiteSpace: 'nowrap',
                          textTransform: 'capitalize',
                          fontSize: '0.7rem'
                        }}
                      >
                        {item.submissionData.type === 'position'
                          ? item.submissionData.jobIdTitle
                          : item.submissionData.positionName}
                      </Typography>
                      <Typography sx={{
                        width: '15%', overflow: 'auto', whiteSpace: 'nowrap', color: 'text.secondary',
                        fontSize: '0.7rem', fontWeight: '600', cursor: 'pointer', textTransform: 'capitalize',
                        marginLeft: '12px'
                      }}
                        onClick={() => {
                         
                          getDetails(item?.resumeId)
                        }
                        }
                      >
                        {item.fullName || '-'}
                      </Typography>
                      <Typography sx={{ width: '12%', overflow: 'auto', whiteSpace: 'nowrap',
                         marginLeft: '10px', fontSize: '0.7rem'}}>
                        {item.prospectEmail || '-'}
                      </Typography>
                      <Typography sx={{ width: '9%', marginLeft: '14px', fontSize: '0.7rem' }}>
                        $ {item.submissionData.expectedCompensation || '-'}{' '}
                        {item.submissionData.chargeType === 'Annually' ? 'K' : 'P/H'}
                      </Typography> 
                      <Typography sx={{ width: '10%', fontSize: '0.7rem' }}>
                      {item.submissionData?.visaType === "Canadian citizen" ? "CC" :
   item.submissionData?.visaType === "Open work permit" ? "OWP" :
   item.submissionData?.visaType === "Permanent Resident" ? "PR" :
   item.submissionData?.visaType || "-"}
{item.submissionData?.taxTerm ? ` | ${item.submissionData?.taxTerm}` : ''}

                        </Typography>
                     
                      <Stack sx={{ flexDirection: "row", width: '14%', mt: -0.5 }}>
                      <Typography
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '0.7rem',
    textTransform: 'capitalize',
    color: item.submissionData?.status === "submitted" ? "#3C6BA5" : '',
    cursor: item.submissionData?.status === "submitted" ? 'pointer' : '',
    mt: item?.subStatus === "placement" || item?.subStatus === "rejected" ? 0 : '',
  }}
  onClick={() => {
    if (item.submissionData?.status === "submitted") {
      openStatusModal(item?.submissionData);
    }
  }}
>
  {item.subStatus ? item.subStatus : item.submissionData?.tempSubmitStatus || 'Submitted'}
  {!(item?.subStatus === "placement" || item?.subStatus === "rejected" || 
    item?.subStatus === "Duplicate Submission" || item?.subStatus === "unqualified") && (
      <IconButton
        sx={{ mt: -0.2 }}
        onClick={() => navigate('/resumeDetail', {
          state: {
            row: item?.submissionData,
            fTab: 'interview',
            fallBack: "toclients",
            currentTab,
          },
        })}
      >
        <Iconify
          icon="bxs:right-arrow"
          color="#1E74B3"
          width="14px"
        />
      </IconButton>
    )}
</Typography>

                      </Stack>

                      <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap', fontSize: '0.7rem' }}>
                        {item.presentedBy || '-'}
                      </Typography>
                    </Stack>
                  );
                })
                : null}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

<Modal open={openS} onClose={closeSubmission} style={{ borderRadius: 10 }}>
  <Box sx={[styleClients, { width: {  xs: '60%', sm: '95%' } }]}>
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: { xs: "center", sm: "space-between" },
        width: "100%",
        position: "relative",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h5"
        color="#3C6BA5"
        sx={{
          position: { sm: "absolute" },
          left: { sm: "50%" },
          transform: { sm: "translateX(-50%)" },
          mb: { xs: 1, sm: 0 },
        }}
      >
        Submissions
      </Typography>

      <Stack
        direction="row"
        spacing={1.9}
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-end" },
          width: { xs: "100%", sm: "auto" },
          ml: "auto",
        }}
      >
        <Button color="custom" variant="contained" onClick={() => handleOpenDown()}>
          Export
        </Button>
      </Stack>
    </Box>

    <Divider sx={{ mb: 2, mt: 1 }} />

    <Scrollbar
      sx={{
        maxHeight: 400,
        overflowX: 'auto',
        width: '100%',
      }}
    >
      <Box sx={{ minWidth: '1000px' }}>
        <Stack sx={{ alignItems: 'center' }}>
          <Stack
            sx={{
              backgroundColor: 'text.secondary',
              width: '100%',
              alignItems: 'center',
              p: 0.5,
              borderRadius: 1,
            }}
          >
            <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12%' }}>Date</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '15%' }}>End Client Name</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '16%' }}>Role</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '16%' }}>Name</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13.5%' }}>Email</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '8%' }}>Pay</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>Visa | TT</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '14%' }}>Status</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>Presented By</Typography>
            </Stack>
          </Stack>

          {tempData.length
            ? tempData.map((item, index) => (
              <Stack
                key={item._id || index}
                sx={[
                  {
                    background: index % 2 === 0 ? 'text.background' : tablebg,
                    width: '100%',
                    p: 0.5,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  },
                ]}
              >
                <Typography sx={{ width: '12%', fontSize: '0.7rem' }}>
                  {`${new Date(item.createdAt).toLocaleString('en-US', optionsDate)} 
  ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                </Typography>

                <Typography sx={{ width: '15%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                  {item.submissionData?.endClientName || '-'}
                </Typography>

                <Typography
                  sx={{
                    width: '15%',
                    overflow: 'auto',
                    whiteSpace: 'nowrap',
                    textTransform: 'capitalize',
                    fontSize: '0.7rem',
                  }}
                >
                  {item.submissionData.type === 'position'
                    ? item.submissionData.jobIdTitle
                    : item.submissionData.positionName}
                </Typography>

                <Typography
                  sx={{
                    width: '15%',
                    overflow: 'auto',
                    whiteSpace: 'nowrap',
                    color: 'text.secondary',
                    fontSize: '0.7rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    textTransform: 'capitalize',
                    marginLeft: '12px',
                  }}
                  onClick={() => getDetails(item?.resumeId)}
                >
                  {item.fullName || '-'}
                </Typography>

                <Typography sx={{ width: '12%', overflow: 'auto', whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.7rem' }}>
                  {item.prospectEmail || '-'}
                </Typography>

                <Typography sx={{ width: '9%', marginLeft: '14px', fontSize: '0.7rem' }}>
                  {/* {item?.submissionData?.country ===  "INDIA" ? "₹" :"$"} */}
                  {/* {item?.submissionData?.country === "INDIA"  ? "₹"  : item?.submissionData?.country === "UK" ? "£"  : "$"} */}
                 {localStorage.getItem("country") === "INDIA" ? "₹" : localStorage.getItem("country") === "UK" ? "£" : "$"}
                  {item.submissionData.expectedCompensation || '-'}{' '}
                  {item.submissionData.chargeType === 'Annually' ? localStorage.getItem("country") === "INDIA" ? "Lac":'K' : 'P/H'}
                </Typography>

                <Typography sx={{ width: '10%', fontSize: '0.7rem' }}>
                  {item.submissionData?.visaType === "Canadian citizen" ? "CC" :
                    item.submissionData?.visaType === "Open work permit" ? "OWP" :
                      item.submissionData?.visaType === "Permanent Resident" ? "PR" :
                        item.submissionData?.visaType || "-"}
                  {item.submissionData?.taxTerm ? ` | ${item.submissionData?.taxTerm}` : ''}
                </Typography>

                <Stack sx={{ flexDirection: "row", width: '14%', mt: -0.5 }}>
                  <Typography
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      fontSize: '0.7rem',
                      textTransform: 'capitalize',
                      color: item.submissionData?.status === "submitted" ? "#3C6BA5" : '',
                      cursor: item.submissionData?.status === "submitted" ? 'pointer' : '',
                      mt: item?.subStatus === "placement" || item?.subStatus === "rejected" ? 0 : '',
                    }}
                    onClick={() => {
                      if (item.submissionData?.status === "submitted") {
                        openStatusModal(item?.submissionData);
                      }
                    }}
                  >
                    {item.subStatus ? item.subStatus : item.submissionData?.tempSubmitStatus || 'Submitted'}
                    {!(["placement", "rejected", "Duplicate Submission", "unqualified"].includes(item?.subStatus)) && (
                      <IconButton
                        sx={{ mt: -0.2 }}
                        onClick={() =>
                          navigate('/resumeDetail', {
                            state: {
                              row: item?.submissionData,
                              fTab: 'interview',
                              fallBack: "toclients",
                              currentTab,
                            },
                          })
                        }
                      >
                        <Iconify icon="bxs:right-arrow" color="#1E74B3" width="14px" />
                      </IconButton>
                    )}
                  </Typography>
                </Stack>

                <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap', fontSize: '0.7rem' }}>
                  {item.presentedBy || '-'}
                </Typography>
              </Stack>
            ))
            : null}
        </Stack>
      </Box>
    </Scrollbar>
  </Box>
</Modal>

      {/* <Modal open={openP} onClose={closePlacement} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '60%', sm: '99%' } }]}>
         
           <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        justifyContent: { xs: "center", sm: "space-between" },
                        width: "100%",
                        position: "relative",
                        textAlign: "center",
                      }}
                    >
          
                      <Typography
                        variant="h5"
                        color="#3C6BA5"
                        sx={{
                          position: { sm: "absolute" },
                          left: { sm: "50%" },
                          transform: { sm: "translateX(-50%)" },
                          mb: { xs: 1, sm: 0 },
                        }}
                      >
                       Placements
                      </Typography>
          
                      <Stack
                        direction="row"
                        spacing={1.9}
                        sx={{
                          display: "flex",
                          justifyContent: { xs: "center", sm: "flex-end" },
                          width: { xs: "100%", sm: "auto" },
                          ml: "auto",
                        }}
                      >
                        <Button color="custom" variant="contained" onClick={()=>handleOpenDown()}>Export</Button>
                        
                      </Stack>
                    </Box>
          
                    <Divider sx={{ mb: 2, mt:1 }} />
          
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack sx={{ alignItems: 'center' }}>
              <Stack
                sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
              >
                <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10.5%' }}>
                    Date
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '11%' }}>
                    End Client Name
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '11%' }}>
                    Role
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '11%' }}>
                    Name 
                  </Typography>
                  <Typography
                    sx={{ 
                      color: 'white',
                      fontSize: '0.7rem',
                      fontWeight: '600',
                      width: '8%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    Emp Type
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '8%' }}>
                    Visa | TT
                  </Typography>
                  <Typography
                    sx={{
                      color: 'white',
                      fontSize: '0.7rem',
                      fontWeight: '600',
                      width: '7%',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    Pay
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>
                    Start Date
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>
                    End Date
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>
                    Status
                  </Typography>
                  <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>
                    Presented By
                  </Typography>
                </Stack>
              </Stack>
              {tempData.length
                ? tempData.map((item, index) => {
                  return (
                    <Stack
                      sx={[
                        { background: index % 2 === 0 ? 'text.background' : tablebg },
                        { width: '100%', p: 0.5, flexDirection: 'row', justifyContent: 'space-between' },
                      ]}
                    >
                      <Typography sx={{ width: '11%', fontSize: '0.7rem'  }}>
                       
                        {`${new Date(item?.createdAt)?.toLocaleString('en-US', optionsDate)} 
 ${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}`}:{`${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                      </Typography>
                      <Typography sx={{ width: '11%', textTransform: 'capitalize', fontSize: '0.7rem'  }}>
                                        {item.submissionData?.endClientName|| '-'}
                                        
                                      </Typography>
                      <Typography
                        sx={{
                          
                          width: '10%',
                          textTransform: 'capitalize',
                          overflow: 'auto',
                          whiteSpace: 'nowrap',
                          fontSize: '0.7rem' 
                          
                        }}
                      >
                        {item.submissionData.type === 'position'
                          ? item.submissionData.jobIdTitle
                          : item.submissionData.positionName}
                      </Typography>
                      <Typography
                        sx={{
                          width: '10.7%', textTransform: 'capitalize', overflow: 'auto', whiteSpace: 'nowrap',
                          color: 'text.secondary', fontSize: '0.7rem', fontWeight: '600', cursor: 'pointer', marginLeft: "11px"
                        }}
                        onClick={() => {
                          
                          getDetails(item?.resumeId)
                        }
                        }
                      >
                        {item.fullName || '-'}
                      </Typography>
                      <Typography sx={{ width: '8%', textTransform: 'capitalize', marginLeft: "11px", fontSize: '0.7rem'  }}>
                        {item.submissionData.offeredJob || '-'}
                      </Typography>
                      <Typography sx={{ width: '8%', fontSize: '0.7rem'  }}>
                      {item.submissionData?.visaType === "Canadian citizen" ? "CC" :
   item.submissionData?.visaType === "Open work permit" ? "OWP" :
   item.submissionData?.visaType === "Permanent Resident" ? "PR" :
   item.submissionData?.visaType || "-"} 
{item.submissionData?.taxTerm ? ` | ${item.submissionData.taxTerm}` : ''}

</Typography>  

                      <Typography sx={{ width: '8%', fontSize: '0.7rem'  }}>
                        ${item.submissionData.expectedCompensation}{' '}
                        {item.submissionData.chargeType === 'Annually' ? 'K' : 'P/H'}
                      </Typography>
                      <Typography sx={{ width: '10%' , fontSize: '0.7rem' }}>
                        {`${new Date(item?.submissionData?.tentativeStartDate).toLocaleString('en-US', optionsDate)}`}
                      </Typography>
                      <Typography sx={{ width: '10%', fontSize: '0.7rem'  }}>
                        {item.submissionData?.terminatedAt ?
                          `${new Date(item?.submissionData?.terminatedAt).toLocaleString('en-US', optionsDate)}`
                          : "-"}
                      </Typography>

                      <Stack sx={{ flexDirection: "row", width: '10%', mt: -0.5 }}>
                        <Typography sx={{ textTransform: 'capitalize' , fontSize: '0.7rem' }}>

                          {item.subStatus ? item.subStatus : item.submissionData.status || '-'}
                          {
                            item.submissionData?.status === "rejected" || (item.subStatus !== "started" && item.subStatus !== "") ? (
                              null
                            ) : (
                              <IconButton sx={{ mt: -0.2 }}
                                onClick={() => navigate('/resumeDetail', {
                                  state: {
                                    row: item?.submissionData, fTab: 'start',
                                    q: item.subStatus === 'started' ? 'quit' : '',
                                    fallBack: "toclients",
                                    currentTab
                                  }
                                })}
                              >
                                <Iconify
                                  icon="bxs:right-arrow"
                                  color="#1E74B3"
                                  width="14px"
                                />
                              </IconButton>
                            )}
                        </Typography>
                      </Stack>

                      <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap' , fontSize: '0.7rem' }}>
                        {item.presentedBy || '-'}
                      </Typography>
                    </Stack> 
                  );
                })
                : null}
            </Stack>
          </Scrollbar>
        </Box>
      </Modal> */}

<Modal open={openP} onClose={closePlacement} style={{ borderRadius: 10 }}>
  <Box sx={[styleClients, { width: { xs: '90%', sm: '99%' } }]}>
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        justifyContent: { xs: "center", sm: "space-between" },
        width: "100%",
        position: "relative",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h5"
        color="#3C6BA5"
        sx={{
          position: { sm: "absolute" },
          left: { sm: "50%" },
          transform: { sm: "translateX(-50%)" },
          mb: { xs: 1, sm: 0 },
        }}
      >
        Placements
      </Typography>

      <Stack
        direction="row"
        spacing={1.9}
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-end" },
          width: { xs: "100%", sm: "auto" },
          ml: "auto",
        }}
      >
        <Button color="custom" variant="contained" onClick={handleOpenDown}>
          Export
        </Button>
      </Stack>
    </Box>

    <Divider sx={{ mb: 2, mt: 1 }} />

    <Box sx={{ overflowX: { xs: 'auto', sm: 'unset' }, width: '100%' }}>
      <Scrollbar sx={{ maxHeight: 400, minWidth: 850 }}>
        <Stack sx={{ alignItems: 'center', minWidth: '100%' }}>
          <Stack
            sx={{
              backgroundColor: 'text.secondary',
              width: '100%',
              alignItems: 'center',
              p: 0.5,
              borderRadius: 1,
            }}
          >
            <Stack
              sx={{
                width: '100%',
                flexDirection: 'row',
                justifyContent: 'space-between',
                minWidth: 850,
              }}
            >
              {[
                'Date', 'End Client Name', 'Role', 'Name', 'Emp Type',
                'Visa | TT', 'Pay', 'Start Date', 'End Date',
                'Status', 'Presented By'
              ].map((label, i) => (
                <Typography
                  key={i}
                  sx={{
                    color: 'white',
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    width: ['10.5%', '11%', '11%', '10.7%', '8%', '8%', '8%', '10%', '10%', '10%', '10%'][i],
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {label}
                </Typography>
              ))}
            </Stack>
          </Stack>

          {tempData.length > 0 &&
            tempData.map((item, index) => (
              <Stack
                key={item._id || index}
                sx={[
                  {
                    background: index % 2 === 0 ? 'text.background' : tablebg,
                    width: '100%',
                    p: 0.5,
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    minWidth: 850
                  }
                ]}
              >
                <Typography sx={{ width: '11%', fontSize: '0.7rem' }}>
                  {`${new Date(item?.createdAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}:${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}
                </Typography>

                <Typography sx={{ width: '11%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                  {item.submissionData?.endClientName || '-'}
                </Typography>

                <Typography
                  sx={{
                    width: '10%',
                    textTransform: 'capitalize',
                    overflow: 'auto',
                    whiteSpace: 'nowrap',
                    fontSize: '0.7rem',
                  }}
                >
                  {item.submissionData.type === 'position'
                    ? item.submissionData.jobIdTitle
                    : item.submissionData.positionName}
                </Typography>

                <Typography
                  sx={{
                    width: '10.7%',
                    textTransform: 'capitalize',
                    overflow: 'auto',
                    whiteSpace: 'nowrap',
                    color: 'text.secondary',
                    fontSize: '0.7rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    marginLeft: '11px',
                  }}
                  onClick={() => getDetails(item?.resumeId)}
                >
                  {item.fullName || '-'}
                </Typography>

                <Typography sx={{ width: '8%', textTransform: 'capitalize', marginLeft: '11px', fontSize: '0.7rem' }}>
                  {item.submissionData.offeredJob || '-'}
                </Typography>

                <Typography sx={{ width: '8%', fontSize: '0.7rem' }}>
                  {item.submissionData?.visaType === 'Canadian citizen' ? 'CC'
                    : item.submissionData?.visaType === 'Open work permit' ? 'OWP'
                    : item.submissionData?.visaType === 'Permanent Resident' ? 'PR'
                    : item.submissionData?.visaType || '-'}
                  {item.submissionData?.taxTerm ? ` | ${item.submissionData.taxTerm}` : ''}
                </Typography>

                <Typography sx={{ width: '8%', fontSize: '0.7rem' }}>
                  {item?.submissionData?.country === "INDIA"  ? "₹"  : item?.submissionData?.country === "UK" ? "£"  : "$"}{item.submissionData.expectedCompensation}
                  {item.submissionData.chargeType === 'Annually' ? 'K' : 'P/H'}
                </Typography>

                <Typography sx={{ width: '10%', fontSize: '0.7rem' }}>
                  {new Date(item?.submissionData?.tentativeStartDate).toLocaleString('en-US', optionsDate)}
                </Typography>

                <Typography sx={{ width: '10%', fontSize: '0.7rem' }}>
                  {item.submissionData?.terminatedAt
                    ? new Date(item?.submissionData?.terminatedAt).toLocaleString('en-US', optionsDate)
                    : '-'}
                </Typography>

                <Stack sx={{ flexDirection: 'row', width: '10%', mt: -0.5 }}>
                  <Typography sx={{ textTransform: 'capitalize', fontSize: '0.7rem' }}>
                    {item.subStatus || item.submissionData.status || '-'}
                    {!(item.submissionData?.status === 'rejected' || (item.subStatus !== 'started' && item.subStatus !== '')) && (
                      <IconButton
                        sx={{ mt: -0.2 }}
                        onClick={() =>
                          navigate('/resumeDetail', {
                            state: {
                              row: item?.submissionData,
                              fTab: 'start',
                              q: item.subStatus === 'started' ? 'quit' : '',
                              fallBack: 'toclients',
                              currentTab,
                            },
                          })
                        }
                      >
                        <Iconify icon="bxs:right-arrow" color="#1E74B3" width="14px" />
                      </IconButton>
                    )}
                  </Typography>
                </Stack>

                <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap', fontSize: '0.7rem' }}>
                  {item.presentedBy || '-'}
                </Typography>
              </Stack>
            ))}
        </Stack>
      </Scrollbar>
    </Box>
  </Box>
</Modal>

      {/* <Modal open={openI} onClose={closeInterview} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '60%', sm: '98%' } }]}>
         
           <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", sm: "row" },
                        alignItems: "center",
                        justifyContent: { xs: "center", sm: "space-between" },
                        width: "100%",
                        position: "relative",
                        textAlign: "center",
                      }}
                    >
          
                      <Typography
                        variant="h5"
                        color="#3C6BA5"
                        sx={{
                          position: { sm: "absolute" },
                          left: { sm: "50%" },
                          transform: { sm: "translateX(-50%)" },
                          mb: { xs: 1, sm: 0 },
                        }}
                      >
                        Interviews
                      </Typography>
          
                      <Stack
                        direction="row"
                        spacing={1.9}
                        sx={{
                          display: "flex",
                          justifyContent: { xs: "center", sm: "flex-end" },
                          width: { xs: "100%", sm: "auto" },
                          ml: "auto",
                        }}
                      >
                        <Button color="custom" variant="contained" onClick={()=>handleOpenDown()}>Export</Button>
                        
                      </Stack>
                    </Box>
          
                    <Divider sx={{ mb: 2, mt:1 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Stack
              sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
            >
              <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '11.5%' }}>
                  Date
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '14%'}}>
                  End Client Name
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13%' }}>
                  Role
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13.5%' }}>
                  Name
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13%' }}>
                  Email
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12.5%' }}>
                  Mode
                </Typography> 
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '11%' }}>
                  Location
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12%' }}>
                  Hiring Manager
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12%' }}>
                  Status
                </Typography>
                <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>
                  Presented By
                </Typography>
              </Stack>
            </Stack>
            {tempData.length
              ? tempData.map((item, index) => {
                return (
                  <Stack
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { p: 0.5, flexDirection: 'row', justifyContent: 'space-between' },
                    ]}
                  >
                    <Typography sx={{ width: '11.1%', fontSize: '0.7rem' }}>
                      {`${new Date(item?.createdAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}`}:{`${String(new Date(item?.createdAt)?.getMinutes())?.padStart(2, '0')}`}

                    </Typography>

                    <Typography sx={{ width: '14%', textTransform: 'capitalize', fontSize: '0.7rem'  }}>
                  {item.submissionData?.endClientName|| '-'}
                </Typography>

                    <Typography
                      sx={{
                       
                        width: '12%',
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        textTransform: 'capitalize',
                        fontSize: '0.7rem' 
                      }}
                    >
                      {item.submissionData.type === 'position'
                        ? item.submissionData.jobIdTitle
                        : item.submissionData.positionName}
                    </Typography>

                    <Typography sx={{
                      overflow: 'auto', whiteSpace: 'nowrap', width: '12%',
                      color: 'text.secondary', fontSize: '0.7rem', fontWeight: '600', cursor: 'pointer',
                      textTransform: 'capitalize', marginLeft:"10px"
                    }}
                      onClick={() => {
                        
                        getDetails(item?.resumeId)
                      }
                      }
                    >

                      {item.fullName || '-'}
                    </Typography>
                    <Typography sx={{ overflow: 'auto', whiteSpace: 'nowrap', width: '12%',
                       marginLeft: '14px', fontSize: '0.7rem'  }}>
                      {item.prospectEmail || '-'}
                    </Typography>
                    <Typography sx={{ textTransform: 'capitalize', width: '13%', marginLeft: '13px', fontSize: '0.7rem'  }}>
                    {item.submissionData?.interviewMode === "phoneic" ? "Telephonic" : item.submissionData?.interviewMode}
                    </Typography>
                    {item.submissionData.interviewMode === 'phoneic' && (
                      <Typography sx={{ width: '11%', fontSize: '0.7rem'  }}>{item.submissionData.contactNo || '-'}</Typography>
                    )}
                    {item.submissionData.interviewMode === 'video' && (
                      <Typography
                        sx={{ color: 'text.secondary', width: '11%', fontSize: '0.7rem'  }}
                        onClick={() => window.open(item.submissionData.meetingLink, '_blank')}
                      >
                        {item.videoPlatform}
                      </Typography>
                    )}
                    {item.submissionData.interviewMode === 'onsite' && (
                      <Typography sx={{ width: '11%', overflow: 'auto', whiteSpace: 'nowrap', fontSize: '0.7rem'  }}>
                        {item.submissionData.companyAddress || '-'}
                      </Typography>
                    )}
                    <Typography sx={{ width: '11%', overflow: 'auto', whiteSpace: 'nowrap', fontSize: '0.7rem'  }}>
                      {item.submissionData.hiringManagerName || '-'}
                    </Typography>
                    
                    <Stack sx={{ flexDirection: "row", width: '12%', mt: -0.5 }}>
                      <Typography sx={{ textTransform: 'capitalize', fontSize: '0.7rem'  }}>

                        {item.subStatus ? item.subStatus : `${item.submissionData?.stepWiseStatus || ''} Interview`}

                        {item.subStatus !== "" ? (
                          null
                        ) : (
                          <IconButton sx={{ mt: -0.2 }}
                            onClick={() => navigate('/resumeDetail', {
                              state: {
                                row: item?.submissionData,
                                fTab: 'placement',
                                fallBack: "toclients",
                                currentTab
                              }
                            })}
                          >
                            <Iconify
                              icon="bxs:right-arrow"
                              color="#1E74B3"
                              width="14px"
                            />
                          </IconButton>
                        )}
                      </Typography>
                    </Stack>

                    <Typography sx={{ width: '10%', overflow: 'auto', whiteSpace: 'nowrap', fontSize: '0.7rem'  }}>
                      {item.presentedBy || '-'}
                    </Typography>
                  </Stack>
                );
              })
              : null}
          </Scrollbar>
        </Box>
      </Modal> */}

<Modal open={openI} onClose={closeInterview} style={{ borderRadius: 10 }}>
  <Box sx={[styleClients, { width: { xs: '60%', sm: '98%' } }]}>
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: { xs: 'center', sm: 'space-between' },
        width: '100%',
        position: 'relative',
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h5"
        color="#3C6BA5"
        sx={{
          position: { sm: 'absolute' },
          left: { sm: '50%' },
          transform: { sm: 'translateX(-50%)' },
          mb: { xs: 1, sm: 0 },
        }}
      >
        Interviews
      </Typography>

      <Stack
        direction="row"
        spacing={1.9}
        sx={{
          display: 'flex',
          justifyContent: { xs: 'center', sm: 'flex-end' },
          width: { xs: '100%', sm: 'auto' },
          ml: 'auto',
        }}
      >
        <Button color="custom" variant="contained" onClick={() => handleOpenDown()}>
          Export
        </Button>
      </Stack>
    </Box>

    <Divider sx={{ mb: 2, mt: 1 }} />

    <Box sx={{ overflowX: { xs: 'auto', sm: 'unset' }, width: '100%' }}>
      <Scrollbar sx={{ maxHeight: 400 }}>
        <Box sx={{ minWidth: { xs: '900px', sm: '100%' } }}>
          <Stack
            sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5, borderRadius: 1 }}
          >
            <Stack sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '11.5%' }}>Date</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '14%' }}>End Client Name</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13%' }}>Role</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13.5%' }}>Name</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '13%' }}>Email</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12.5%' }}>Mode</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '11%' }}>Location</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12%' }}>Hiring Manager</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '12%' }}>Status</Typography>
              <Typography sx={{ color: 'white', fontSize: '0.7rem', fontWeight: '600', width: '10%' }}>Presented By</Typography>
            </Stack>
          </Stack>

          {tempData.length
            ? tempData.map((item, index) => {
                return (
                  <Stack
                    key={index}
                    sx={[
                      { background: index % 2 === 0 ? 'text.background' : tablebg },
                      { p: 0.5, flexDirection: 'row', justifyContent: 'space-between' },
                    ]}
                  >
                    <Typography sx={{ width: '11.1%', fontSize: '0.7rem' }}>
                      {`${new Date(item?.createdAt).toLocaleString('en-US', optionsDate)} 
${String(new Date(item?.createdAt)?.getHours())?.padStart(2, '0')}`}:{`${String(
                        new Date(item?.createdAt)?.getMinutes(),
                      )?.padStart(2, '0')}`}
                    </Typography>

                    <Typography sx={{ width: '14%', textTransform: 'capitalize', fontSize: '0.7rem' }}>
                      {item.submissionData?.endClientName || '-'}
                    </Typography>

                    <Typography
                      sx={{
                        width: '12%',
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        textTransform: 'capitalize',
                        fontSize: '0.7rem',
                      }}
                    >
                      {item.submissionData.type === 'position'
                        ? item.submissionData.jobIdTitle
                        : item.submissionData.positionName}
                    </Typography>

                    <Typography
                      sx={{
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        width: '12%',
                        color: 'text.secondary',
                        fontSize: '0.7rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        textTransform: 'capitalize',
                        marginLeft: '10px',
                      }}
                      onClick={() => {
                        getDetails(item?.resumeId);
                      }}
                    >
                      {item.fullName || '-'}
                    </Typography>

                    <Typography
                      sx={{
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        width: '12%',
                        marginLeft: '14px',
                        fontSize: '0.7rem',
                      }}
                    >
                      {item.prospectEmail || '-'}
                    </Typography>

                    <Typography
                      sx={{
                        textTransform: 'capitalize',
                        width: '13%',
                        marginLeft: '13px',
                        fontSize: '0.7rem',
                      }}
                    >
                      {item.submissionData?.interviewMode === 'phoneic'
                        ? 'Telephonic'
                        : item.submissionData?.interviewMode}
                    </Typography>

                    {item.submissionData.interviewMode === 'phoneic' && (
                      <Typography sx={{ width: '11%', fontSize: '0.7rem' }}>
                        {item.submissionData.contactNo || '-'}
                      </Typography>
                    )}
                    {item.submissionData.interviewMode === 'video' && (
                      <Typography
                        sx={{ color: 'text.secondary', width: '11%', fontSize: '0.7rem' }}
                        onClick={() => window.open(item.submissionData.meetingLink, '_blank')}
                      >
                        {item.videoPlatform}
                      </Typography>
                    )}
                    {item.submissionData.interviewMode === 'onsite' && (
                      <Typography
                        sx={{
                          width: '11%',
                          overflow: 'auto',
                          whiteSpace: 'nowrap',
                          fontSize: '0.7rem',
                        }}
                      >
                        {item.submissionData.companyAddress || '-'}
                      </Typography>
                    )}

                    <Typography
                      sx={{
                        width: '11%',
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        fontSize: '0.7rem',
                      }}
                    >
                      {item.submissionData.hiringManagerName || '-'}
                    </Typography>

                    <Stack sx={{ flexDirection: 'row', width: '12%', mt: -0.5 }}>
                      <Typography sx={{ textTransform: 'capitalize', fontSize: '0.7rem' }}>
                        {item.subStatus
                          ? item.subStatus
                          : `${item.submissionData?.stepWiseStatus || ''} Interview`}

                        {item.subStatus !== '' ? null : (
                          <IconButton
                            sx={{ mt: -0.2 }}
                            onClick={() =>
                              navigate('/resumeDetail', {
                                state: {
                                  row: item?.submissionData,
                                  fTab: 'placement',
                                  fallBack: 'toclients',
                                  currentTab,
                                },
                              })
                            }
                          >
                            <Iconify icon="bxs:right-arrow" color="#1E74B3" width="14px" />
                          </IconButton>
                        )}
                      </Typography>
                    </Stack>

                    <Typography
                      sx={{
                        width: '10%',
                        overflow: 'auto',
                        whiteSpace: 'nowrap',
                        fontSize: '0.7rem',
                      }}
                    >
                      {item.presentedBy || '-'}
                    </Typography>
                  </Stack>
                );
              })
            : null}
        </Box>
      </Scrollbar>
    </Box> 
  </Box>
</Modal>

      <Modal open={openClient} onClose={closeClientD} style={{ borderRadius: 1 }}>
        <Box sx={styleClients}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Details
          </Typography>
          {/* <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Divider />
            <Stack sx={{ alignItems: 'center' }}>
              <Stack sx={{ backgroundColor: 'text.secondary', width: '100%', alignItems: 'center', p: 0.5,borderRadius: 1}}>
                <Stack
                  sx={{ width: '100%', flexDirection: 'row', justifyContent: 'space-between' }}
                >
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Date
                  </Typography>
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Role
                  </Typography>
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Name
                  </Typography>
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Email
                  </Typography>
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Compensation
                  </Typography>
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Tax Term
                  </Typography>
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                   Status
                  </Typography>
                  <Typography sx={{  color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                    Presented By
                  </Typography>
                  
                </Stack>
              </Stack>
            </Stack>
          </Scrollbar> */}
        </Box>
      </Modal>

      <Modal open={openstatus} onClose={statusCloses} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '60%', sm: '50%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Change Status
          </Typography>
          <Divider sx={{}} />

          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid container sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} gap={2}>
              <FormControl fullWidth sx={{ mt: 2 }}>
                <InputLabel id="demo-simple-select-label">Select Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select Status"
                  value={statuss}
                  onChange={(e) => setStatuss(e.target.value)}
                >
                  <MenuItem value={'Active'}>Active</MenuItem>;<MenuItem value={'Inactive'}>Inactive</MenuItem>;
                  <MenuItem value={'On Hold'}>On Hold</MenuItem>;
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer sx={{ mt: -0.8 }} components={['DatePicker', 'DatePicker']}>
                    <DatePicker
                      disablePast
                      label="Date"
                      sx={{ width: '100%' }}
                      value={statusDate}
                      onChange={(newValue) => setStatusDate(newValue)}
                    //   slotProps={{
                    //     textField: {
                    //         readOnly: true,
                    //     },
                    // }}
                    // console.log("uncontrol date",newValue)}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  multiline
                  id="outlined-multiline-static"
                  label="Note"
                  value={statusNote}
                  onChange={(e) => setStatusNote(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button
                disabled={!statuss}
                color="custom"
                variant="contained"
                sx={{ width: '10%', mt: 2 }}
                onClick={() => changeClientStatus()}
              >
                Submit
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={changeJobstatus} onClose={jobStatusCloses} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { width: { xs: '60%', sm: '50%' } }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Change Job Status
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid
              container
              sx={{ mt: 2, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
              gap={2}
            >
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Select Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select New Status"
                  value={statuss}
                  onChange={(e) => setStatuss(e.target.value)}
                >
                  <MenuItem value={'Active'}>Active</MenuItem>
                  <MenuItem value={'On Hold'}>On Hold</MenuItem>
                  <MenuItem value={'Closed'}>Closed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button color="custom" variant="contained" sx={{ width: '10%', mt: 2 }} onClick={() => changeJob()}>
                Submit
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openAss} onClose={assCloses} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { p: 1, width: '60%' }]}>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'}>
            Assign Professionals
          </Typography>
          <Divider sx={{}} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin', p: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Select Resources</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Select Resources"
                placeholder="Select Resources"
                value={member}
                onChange={(e) => {
                  setMember(e.target.value);
                  if (e.target.value === 'all') {
                    AllAsignData();
                  } else {
                    setAllAssign(false);
                    setAssignee([]);
                  }
                }}
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'individual'}>Individual</MenuItem>
                <MenuItem value={'team'}>Team</MenuItem>
              </Select>
            </FormControl>
            {member === 'team' && (
              <>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <InputLabel id="demo-simple-select-label">Select Role</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select Resources"
                    placeholder="Select Resources"
                    value={tempRole}
                    onChange={(e) => {
                      setTempRole(e.target.value);
                      handleRole(e.target.value);
                    }}
                  >
                    <MenuItem value={'recruiterHead'}>RH</MenuItem>
                    <MenuItem value={'recruiterManager'}>RM</MenuItem>
                    <MenuItem value={'recruiterTeamLead'}>RL</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth sx={{ mt: 1 }}>
                  <InputLabel id="demo-multiple-checkbox-label">Users</InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    // multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label="Tag" />}
                  // renderValue={(selected) => selected.join(', ')}
                  // MenuProps={MenuProps}
                  >
                    {roleUsers?.map((name, index) => (
                      <MenuItem key={name._id} value={index}>
                        {/* <Checkbox checked={personName.indexOf(name.contactPersonName) > -1} value={name._id}  /> */}
                        <ListItemText primary={name.contactPersonName} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {selectUser.length > 0 && (
                  <Grid
                    container
                    gridTemplateColumns={{ sm: 'repeat(8, 1fr)', xs: 'repeat(8, 1fr)' }}
                    sx={{ mt: 1, gap: 1 }}
                  >
                    {selectUser?.map((item, index) => {
                      return (
                        <Stack
                          sx={{
                            flexDirection: 'row',
                            border: 1,
                            borderRadius: 1,
                            p: 0.5,
                            borderColor: 'text.secondary',
                          }}
                        >
                          <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                            {item.contactPersonName}
                          </Typography>
                          <Icon
                            icon="jam:close"
                            color={'red'}
                            fontSize={16}
                            sx={{ cursor: 'pointer', mt: -1 }}
                            onClick={() => handleRoleUser(index)}
                          />
                        </Stack>
                      );
                    })}
                  </Grid>
                )}

                <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                  {underRole?.map((item, index) => {
                    return (
                      <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                        {/* return<Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(2, 1fr)' }} py={1} gap={2}> */}
                        <FormControlLabel
                          control={<Checkbox defaultChecked disabled />}
                          value={item._id}
                        // onChange={(e) => asignData(e)}
                        />
                        <Typography sx={{ ml: -3 }}>
                          {item.contactPersonName} {item.USERID}
                        </Typography>
                        {/* <Typography sx={{ml:1}}>{item.USERID}</Typography> */}
                      </Stack>
                    );
                  })}
                </Grid>
              </>
            )}
            {member === 'individual' && (
              <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                {allUsers?.map((item, index) => {
                  return (
                    <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                      {/* return<Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(2, 1fr)' }} py={1} gap={2}> */}
                      <FormControlLabel control={<Checkbox />} value={item._id} onChange={(e) => asignData(e)} />
                      <Typography sx={{ ml: -3 }}>
                        {item.contactPersonName} {item.USERID}
                      </Typography>
                      {/* <Typography sx={{ml:1}}>{item.USERID}</Typography> */}
                    </Stack>
                  );
                })}
              </Grid>
            )}
            {member === 'all' && (
              <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                {allUsers.map((item, index) => {
                  return (
                    <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                      {/* return<Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(2, 1fr)' }} py={1} gap={2}> */}
                      <FormControlLabel
                        control={<Checkbox checked={allAssign} />}
                        value={item._id}
                      // onChange={(e) => asignData(e)}
                      />
                      <Typography sx={{ ml: -3 }}>
                        {item.contactPersonName} {item.USERID}
                      </Typography>
                      {/* <Typography sx={{ml:1}}>{item.USERID}</Typography> */}
                    </Stack>
                  );
                })}
              </Grid>
            )}
            {/* <Grid container sx={{ mt: 2 ,flexDirection:'column',justifyContent:'center',alignItems:'center'}}  gap={2}>
            
            
          </Grid> */}
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button color="custom" variant="contained" sx={{ width: '10%', mt: 2 }} onClick={() => assignClient()}>
                {/* Submit */}
                {loadingAssignee ? <CircularProgress size={24} /> : 'Submit'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>
      <Modal
        open={openEdit}
        onClose={editClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={[styleClients, { width: { xs: '95%', sm: '75%' } }]}>
          <Typography variant="h5" textAlign={'center'} color={'text.secondary'}>
            Edit Client
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin' }}>
            <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(2, 1fr)', xs: 'repeat(1, 1fr)' }} py={1} gap={2}>
              <Stack gap={2}>
                <TextField
                  id="outlined-basic"
                  disabled
                  label="Client Id"
                  placeholder="Enter Manually / Automatically Assigned if Blank"
                  variant="outlined"
                  value={formValues?.companyID}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, companyID: e.target.value })}
                />
                <TextField

                  id="outlined-basic"
                  label="Client Name"
                  placeholder="Client Name"
                  variant="outlined"
                  value={formValues?.ClientName}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, ClientName: e.target.value })}
                />

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Domain</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    // value={Values.domain}
                    value={formValues.domain}
                    label="Domain"
                    // InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, domain: e.target.value })}
                  >
                    {Domains.map((item) => {
                      return <MenuItem value={item}>{item}</MenuItem>
                    })}

                  </Select>
                </FormControl>

                {/* <TextField
                  id="outlined-basic"
                  label="Domain"
                  placeholder="Domain"
                  variant="outlined"
                  value={formValues?.domain}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, domain: e.target.value })}
                /> */}

                <TextField
                  id="outlined-basic"
                  label="Phone"
                  placeholder="Phone"
                  variant="outlined"
                  value={formValues.phone}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, phone: e.target.value })}
                />
                <TextField
                  id="outlined-basic"
                  label="Linkedin URL"
                  placeholder="Linkedin URL"
                  variant="outlined"
                  value={formValues?.linkedinUrl}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, linkedinUrl: e.target.value })}
                />
                {/* <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Industry</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Industry"
                    placeholder="Industry"
                    value={formValues?.industry}
                    onChange={(e) => setFormValues({ ...formValues, industry: e.target.value })}
                  >
                    <MenuItem value="IT">IT</MenuItem>
                    <MenuItem value="Healthcare">Healthcare</MenuItem>
                    <MenuItem value="Engineering">Engineering</MenuItem>
                    <MenuItem value="Manufacturing">Manufacturing</MenuItem>
                    <MenuItem value="non IT">non IT</MenuItem>
                    <MenuItem value="Finance">Finance</MenuItem>
                    <MenuItem value="Pharma">Pharma</MenuItem>
                    <MenuItem value="Hospitality">Hospitality</MenuItem>
                    <MenuItem value="All">All</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl> */}
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Country</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Country"
                    placeholder="Country"
                    value={formValues.country}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, country: e.target.value })}
                  >
                    {/* <MenuItem value={'USA'}>USA</MenuItem>;
                    <MenuItem value={'CANADA'}>CANADA</MenuItem>;
                     <MenuItem value={'INDIA'}>INDIA</MenuItem>; */}
                     {countries?.map((item) => (
      <MenuItem key={item.id} value={item.country}>
        {item.country}
      </MenuItem>
    ))}
                  </Select>
                </FormControl>
                <FormControl>
                  <CustomComplete
                    placeholder={'City'}
                    option={cityAndZip}
                    propVal={cityy}
                    childFuc={childFuc}
                    fullVal={fullVal}
                    fetch={'state'}
                    err={err}
                  helperText={helperText}
                  />
                </FormControl>
                <TextField
                  id="outlined-basic"
                  label="Industry"
                  placeholder="Industry"
                  variant="outlined"
                  value={formValues?.industry}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, industry: e.target.value })}
                />

                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Client Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Client type"
                    placeholder="Client type"
                    value={formValues?.RPO_Staffing}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, RPO_Staffing: e.target.value })}
                  >
                    <MenuItem value="RPO">RPO</MenuItem>
                    <MenuItem value="Staffing">Staffing</MenuItem>
                    <MenuItem value="Consulting">Consulting</MenuItem>
                    <MenuItem value="MSP">MSP</MenuItem>
                    <MenuItem value="Contingent">Contingent</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>

                <FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      sx={{ width: '100%' }}
                      label={'Contract Signed Date'}
                      value={dayjs(formValues?.contractDate)}
                      onChange={(e) => setFormValues({ ...formValues, contractDate: e })}
                    />
                  </LocalizationProvider>
                </FormControl>

                <TextField
                  id="outlined-basic"
                  label="Client Source"
                  placeholder="Client Source"
                  variant="outlined"
                  value={formValues?.clientSource}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, clientSource: e.target.value })}
                />

                <Stack sx={{ position: 'relative' }}>
                  <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    <Stack
                      sx={{
                        cursor: 'pointer',
                        m: 1,
                        border: 1,
                        p: 1,
                        borderRadius: 2,
                        width: 'fit-content',
                        borderColor: 'text.secondary',
                      }}
                    >
                      <Typography sx={{ alignSelf: 'center' }} color={'text.secondary'}>
                        Upload Contract
                      </Typography>
                    </Stack>
                    <input
                      style={{ opacity: 0, position: 'absolute', margin: 5, width: 100 }}
                      type="file"
                      onChange={(e) => {
                        pdfUpload(e.target.files[0]);
                      }}
                    />
                    {uploadLoader && <CircularProgress />}
                  </Stack>
                  {formValues.contractUrl || docfile ? (
                    <Typography>{docfile || 'Contract already Uploaded'}</Typography>
                  ) : null}
                </Stack>
              </Stack>
              <Stack gap={2}>
                <TextField
                  id="outlined-basic"
                  label="Email"
                  placeholder="Email"
                  variant="outlined"
                  value={formValues?.email}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
                />
                <FormControl>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      sx={{ width: '100%' }}
                      label={'Start Date'}
                      value={startDatee}
                      onChange={(e) => {
                        setStartDate(e);
                        // console.log('e', e);
                      }}
                    />
                  </LocalizationProvider>
                </FormControl>

                <TextField
                  id="outlined-basic"
                  label="Number of Employees"
                  placeholder="Number of Employees"
                  variant="outlined"
                  value={formValues?.employeeNo}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, employeeNo: e.target.value })}
                />
                <TextField
                  id="outlined-basic"
                  label=" Main Contact Name"
                  placeholder="Main Contact Name"
                  variant="outlined"
                  value={formValues?.mainContactName}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, mainContactName: e.target.value })}
                />

                <TextField
                  id="outlined-basic"
                  label="Website URL"
                  placeholder="Website URL"
                  variant="outlined"
                  value={formValues?.websiteUrl}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, websiteUrl: e.target.value })}

                // onChange={(e) => {
                //   let updatedUrl = e.target.value.trim();
                //   updatedUrl = updatedUrl.replace(/^(https?:\/\/)?(www\.)?/i, '');

                //   if (updatedUrl.startsWith('www')) {
                //     updatedUrl = `https://${updatedUrl}`;
                //   } else if (updatedUrl !== '') {
                //     updatedUrl = `https://www.${updatedUrl}`;
                //   }

                //   setFormValues({ ...formValues, websiteUrl: updatedUrl });
                // }}

                />
                <TextField
                  id="outlined-basic"
                  label="Complete  Address"
                  placeholder="Complete Address"
                  variant="outlined"
                  value={formValues?.completeAddress}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, completeAddress: e.target.value })}
                />

                <FormControl size="small" fullWidth sx={{ mt: -0.6 }}>
                  <FormLabel id="demo-radio-buttons-group-label">Fees Type</FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    size="small"
                    name="radio-buttons-group"
                    sx={{ flexDirection: 'row' }}
                    value={formValues.amountType}
                    onChange={(e) => setFormValues({ ...formValues, amountType: e.target.value })}
                  >
                    <FormControlLabel value="Percentage Basis" label="Percentage" control={<Radio size="small" />} />
                    <FormControlLabel value="Flat Fee" label="Flat Fee" control={<Radio size="small" />} />
                    <FormControlLabel value="Margin Basis" label="Margin" control={<Radio size="small" />} />
                    <FormControlLabel value="Subscription" label="Subscription" control={<Radio size="small" />} />
                  </RadioGroup>
                </FormControl>
                {formValues.amountType === 'Subscription' ? (
                  <>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Subscription Plan</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Subscription Plan"
                        placeholder="Subscription Plan"
                        value={formValues.subPlan}
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) => setFormValues({ ...formValues, subPlan: e.target.value })}
                      >
                        <MenuItem value="month">Month</MenuItem>
                        <MenuItem value="quater">Quater</MenuItem>
                        <MenuItem value="year">Year</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      id="outlined-basic"
                      label=""
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        endAdornment: <InputAdornment position="end">per/{formValues?.subPlan}</InputAdornment>,
                      }}
                      value={formValues.amountValue}
                      onChange={(e) => setFormValues({ ...formValues, amountValue: e.target.value })}
                    />
                    <FormControl>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={{ width: '100%' }}
                          label={'Billing Date'}
                          value={dayjs(formValues.billingDate)}
                          onChange={(e) => setFormValues({ ...formValues, billingDate: e })}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </>
                ) : (
                  <TextField
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          {formValues?.amountType !== 'Percentage Basis' ? '$' : null}
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          {formValues?.amountType === 'Percentage Basis'
                            ? '%'
                            : formValues?.amountType === 'Margin Basis'
                              ? 'P/H'
                              : 'K'}
                        </InputAdornment>
                      ),
                    }}
                    value={formValues?.amountValue}
                    onChange={(e) => setFormValues({ ...formValues, amountValue: e.target.value })}
                  />
                )}
                <TextField
                  id="outlined-basic"
                  label="Sales Persons"
                  placeholder="Sales Persons"
                  variant="outlined"
                  value={formValues?.salesPerson}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setFormValues({ ...formValues, salesPerson: e.target.value })}
                />
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Status"
                    placeholder="Status"
                    value={formValues?.status}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) => setFormValues({ ...formValues, status: e.target.value })}
                  >
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    <MenuItem value="on Hold">on Hold</MenuItem>
                  </Select>
                </FormControl>
                {/* {formValues?.status && (
                      <FormControl>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ width: '100%' }}
                            label={formValues?.RPO_Staffing === 'RPO' ? 'Billing Date' : 'Contract Signed Date'}
                            value={dayjs(formValues?.contractDate)}
                            onChange={(e) =>
                              setFormValues({ ...formValues, contractDate: new Date(e.$d).toLocaleDateString() })
                            }
                          />
                        </LocalizationProvider>
                      </FormControl>
                    )} */}
              </Stack>
            </Grid>
            <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
              <Button variant="contained" color="custom" onClick={() => UpdateClient()}
              disabled={loadingEdit}
                >
                {/* Update Client */}
                 {loadingEdit ? <CircularProgress size={21} /> : 'Update Client'}
              </Button>
            </Stack>
          </Scrollbar>
        </Box>
      </Modal>

      <Modal open={openClientlist} onClose={closeCList} style={{ borderRadius: 10 }}>
        <Box sx={[styleClients, { p: 1, width: '90%' }]}>
          <Stack sx={{ width: '100%', alignItems: 'flex-end' }}>
            <Icon icon="bx:edit" fontSize={16} sx={{ cursor: 'pointer', mt: -1 }} onClick={() => setEditAssign(true)} />
          </Stack>
          <Typography variant="h5" color={'#3C6BA5'} textAlign={'center'} sx={{ mt: -3 }}>
            {!editAssign ? 'Assigned' : 'Unassigned'} Professionals
          </Typography>

          <Divider sx={{}} />
          <Scrollbar sx={{ maxHeight: 400, Scrollbar: 'thin', p: 2 }}>
            <>
              {!editAssign ? (
                <>
                  <Grid display={'grid'} gap={1} gridTemplateColumns={{ sm: 'repeat(3, 1fr)', xs: 'repeat(3, 1fr)' }}>
                    <Stack
                      sx={{
                        flexDirection: 'row',
                        backgroundColor: 'text.secondary',
                        width: '100%',
                        alignItems: 'center',
                        p: 0.5,
                        borderRadius: 1,
                      }}
                    >
                      <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                        User ID
                      </Typography>
                      <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                        Name
                      </Typography>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: 'row',
                        backgroundColor: 'text.secondary',
                        width: '100%',
                        alignItems: 'center',
                        p: 0.5,
                        borderRadius: 1,
                      }}
                    >
                      <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                        User ID
                      </Typography>
                      <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                        Name
                      </Typography>
                    </Stack>
                    <Stack
                      sx={{
                        flexDirection: 'row',
                        backgroundColor: 'text.secondary',
                        width: '100%',
                        alignItems: 'center',
                        p: 0.5,
                        borderRadius: 1,
                      }}
                    >
                      <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                        User ID
                      </Typography>
                      <Typography sx={{ width: '50%', color: 'white', fontSize: '0.976rem', fontWeight: '600' }}>
                        Name
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid display={'grid'} gap={1} gridTemplateColumns={{ sm: 'repeat(3, 1fr)', xs: 'repeat(3, 1fr)' }}>
                    {clientUserList.map((item, index) => {
                      return (
                        <Stack
                          sx={[
                            { background: index % 2 === 0 ? 'text.background' : tablebg },
                            { width: '100%', flexDirection: 'row', justifyContent: 'space-between', p: 1 },
                          ]}
                        >
                          <Typography sx={{ width: '50%' }}>{item.USERID}</Typography>
                          <Typography
                            sx={{
                              width: '50%',
                              textTransform: 'capitalize',
                              fontWeight: '600',
                              color: 'text.secondary',
                            }}
                          >
                            {item.contactPersonName}
                          </Typography>
                        </Stack>
                      );
                    })}
                  </Grid>
                </>
              ) : (
                <>
                  <Grid display={'grid'} gridTemplateColumns={{ sm: 'repeat(4, 1fr)', xs: 'repeat(4, 1fr)' }}>
                    {clientUserList?.map((item, index) => {
                      return (
                        <Stack key={index} sx={{ flexDirection: 'row', alignItems: 'center' }}>
                          <FormControlLabel control={<Checkbox />} value={item._id} onChange={(e) => unAsignData(e)} />
                          <Typography sx={{ ml: -3 }}>
                            {item.contactPersonName} {item.USERID}
                          </Typography>
                        </Stack>
                      );
                    })}
                  </Grid>
                  <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Button
                      color="custom"
                      variant="contained"
                      sx={{ width: '10%', mt: 2 }}
                      onClick={() => unAssignClient()}
                    >
                      Unassign
                    </Button>
                  </Stack>
                </>
              )}
            </>
          </Scrollbar>
        </Box>
      </Modal>
    </>
  );
};

export default Clients;

const StyledIconButtonWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
});

function Search({ searchData, func, funcc, funnc, onData, resetSearch, onData1, onData2 }) {
  const [open, setOpen] = useState(false);

  const [formValues, setFormValues] = useState({
    commonSearch: "",
  });

  const [Values, setValues] = useState({
    commonSearch: "",
    addedBy: "",
    status: "",
    fromDate: "",
    toDate: "",
    domain: ""
  });

  // console.log("Values.fromDate", (Values.fromDate))
  // console.log("Values.fromDate", Values.toDate)
  const [loading, setLoading] = useState('')
  const [loadingData, setLoadingData] = useState('')
  const CommonSearcFun = (page = 1) => {
    setLoading(true);
    setLoadingData('Loading...')
    const body = {
      "commonSearch": Values.commonSearch,
      "resource": Values.addedBy,
      "status": Values.status,

      "fromDate": Values.fromDate,
      "toDate": Values.toDate,
      "domain": Values.domain,
      "page": page,
      "limit": "50"
    }

    const token = localStorage.getItem('token');
    Api('common/search/direct/clients', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // searchData(response.data.data)
            if (response.data.data && response.data.data.length > 0) {
              // searchData(response.data.data);
              const totalPage = Math.ceil(response.data?.count / 35)
              searchData(response.data.data, response.data.count, totalPage)
              setLoadingData('');
              setLoading(false);
            } else {
              searchData([]);
            }
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };


  const clearInputField = () => {
    setValues({
      ...Values,
      commonSearch: '',
      addedBy: "",
      status: "",
      fromDate: "",
      toDate: "",
      domain: ""
    });
  }

  const handleDateChange = (date, field) => {
    const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ss[Z]');
    setValues((prevRec) => ({
      ...prevRec,
      [field]: formattedDate
    }));
    // console.log("formattedDate====>>>>", formattedDate);
  };

  // const handleDateChange = (date, field) => {
  //   console.log("date", date)
  //   console.log("field", date)
  //   setValues((prevValues) => ({
  //     ...prevValues,
  //     [field]: date ? moment(date, moment.ISO_8601) : null,

  //   }));
  // };
  const [loading1, setLoading1] = useState(false);

  const fn = (page = 1) => {
    setLoading1(true)
    const body = {
      "commonSearch": formValues.commonSearch,
      "page": page,
      "limit": "50"
    }
    const token = localStorage.getItem('token');
    Api('common/search/direct/clients', 'POST', body, token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          if (response.data.code === 200) {
            // searchData(response.data.data)
            const totalPage = Math.ceil(response.data?.count / 35)
            searchData(response.data.data, response.data.count, totalPage)
            setLoadingData('');
            setLoading(false);
            setLoading1(false)
          } else {
            // console.log('Error:', response.data.message);
          }
        }
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    resetSearch()
    clearInputField()
    setIsVisible(!isVisible);
    func()
    setFormValues({ ...formValues, commonSearch: '' });
  };

  const [searchOpen, setSearchOpen] = useState(false);

  const handleSearchOpen = () => {
    setSearchOpen(true);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  // useEffect(() => {
  //   allUsers()
  // }, []);

  const [resourData, setResourData] = useState([])

  // console.log("resourData", resourData)

  const allUsers = () => {
    const token = localStorage.getItem('token');
    Api('company/clientAddedByList', 'GET', '', token)
      .then((response) => {
        // console.log('Response:---------', response);
        if (response.status === 200) {
          setResourData(response?.data?.result);
          if (response.data.code === 200) {
            // console.log("hhh")
          } else {
            // console.log('Error:', response.data.message);
          }
        } 
      })
      .catch((error) => {
        // console.error("Error:", error);
      });
  };

  // const allUsers = () => {
  //   const token = localStorage.getItem('token');
  //   Api('common/users/SL', 'GET', '', token)
  //     .then((response) => {
  //       console.log('Response:---------', response);
  //       if (response.status === 200) {
  //         if (response.data.code === 200) {
  //           setResourData(response.data.data);
  //         } else {
  //           console.log('Error:', response.data.message);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // };   

  const Domains = [
    "Information Technology",
    "Engineering",
    "Construction",
    "Manufacturing",
    "Healthcare",
    "Production",
    "Automation & Controls",
    "Finance & Accounting",
    "Fintech",
    "Banking",
    "E-Commerce",
    "Supply Chain Management",
    "Science & Innovation",
    "Hospitality",
    "Food & Drink",
    "Real Estate",
    "Energy",
    "Sales",
    "Retail",
    'Trading &  Stocks',
    "Oil & Gas",
    "Logistics",
    "Aerospace",
    "Mining",
    "Pharmaceuticals",
    "Agriculture",
    "Insurance",
    "Gaming",
    "Travel & Tourism",
    "Educational",
    "Edtech",
    "Telecommunication",
    "Gov",
    "Defense",
    "Media & Entertainment",
    "Marketing",
    "Advertising",
    "Others"
  ]

  const sendDataToParent1 = () => {
    onData1(CommonSearcFun, loadingData);
  };

  const [pageNumber, setPageNumber] = useState(1)

  const sendDataToParent2 = () => {
    onData2(pageNumber);
  };

  return (
    <>
      <ClickAwayListener onClickAway={handleClose}>
        <div>

          {/* {!open && (
          <IconButton onClick={handleOpen}>
            <Iconify icon="eva:search-fill" sx={{ color: 'text.primary', width: 30, height: 30 }} />
          </IconButton>
        )} */}

          <div className='mob_search'>
            <Paper
              component="form"
              sx={{
                // p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                border: '1px solid #1E74B3',
                borderRadius: '10px',
                marginTop: -18,
              }}
            >
              {/* <IconButton sx={{ p: '0.1px', ml: "7px" }}>
              <Iconify icon="eva:search-outline" />
            </IconButton> */}
              <InputBase
                sx={{ flex: 1, color: 'text.primary', border: 'none', outline: 'none', pl: 1 }}
                placeholder="Client Id | Client Name | Client Email"
                inputProps={{ 'aria-label': 'search' }}
                value={formValues.commonSearch}
                onChange={(e) => setFormValues({ ...formValues, commonSearch: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    fn();
                    sendDataToParent1()
                    funcc()
                  }

                }}
              />
            </Paper>
            {/* <Button style={{ marginLeft: '16px', color: 'white', backgroundColor: '#1E74B3', borderRadius: '10px', marginTop: '4px', height: '41px', width: '130px' }} onClick={fn}>Search</Button> */}
            <Button color="custom" variant="contained" size="small" sx={{ ml: 1.6, mt: -18 }}
              onClick={() => { fn(); funcc() }}

              disabled={loading1}

            >
              {loading1 ? <CircularProgress size={24} /> : 'Search'}
            </Button>
            {/* {formValues.commonSearch && ( */}
            {(formValues.commonSearch ||
              Values?.commonSearch ||
              Values?.addedBy ||
              Values?.status ||
              Values?.fromDate ||
              Values?.toDate ||
              Values?.domain
            ) && (
                <Button color="custom" variant="contained" size="small"
                  sx={{ ml: 1.6, mt: -18 }}
                  onClick={() => { toggleVisibility(); funnc(); sendDataToParent2() }}>
                  Close
                </Button>
              )}

          </div>
          <StyledIconButtonWrapper onClick={handleSearchOpen}>
            <IconButton className='morFiltr'>
              <Iconify
                icon="bxs:down-arrow"
                color="#1E74B3"
              />
            </IconButton>
          </StyledIconButtonWrapper>
        </div>
      </ClickAwayListener>

      <Modal open={searchOpen} onClose={handleSearchClose}>

        <Box className="morFltr_pop" sx={{
          position: 'absolute',
          top: '31%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '70%' },
          // width: { xs: '85%', sm: '60%' },
          bgcolor: 'background.paper',
          border: '3px solid #3C6BA5',
          boxShadow: 24,
          p: 2,
          borderRadius: 3,
        }}
        >

          <Grid container spacing={1} justifyContent="center">

            <Grid item xs={12} >
              <TextField
                label="Client ID / Client Name / Client Email"
                variant="outlined"
                fullWidth
                margin="dense"
                size="small"

                value={Values.commonSearch}
                onChange={(e) => setValues({ ...Values, commonSearch: e.target.value })}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    CommonSearcFun();
                    handleSearchClose();
                    funcc()
                  }

                }}
              />
            </Grid>

            <Grid container sx={{ flexDirection: "row", marginLeft: '1px' }} spacing={1}>
              <Grid item xs={6} sx={{ marginTop: "1.5px" }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From"
                      slotProps={{ textField: { size: "small" } }}

                      value={Values.fromDate ? dayjs(Values.fromDate) : null}

                      // value={Values.fromDate}
                      onChange={(date) => handleDateChange(date, 'fromDate')}
                    // onChange={(date) => handleDateChange(date, 'fromDate')}
                    // onChange={(date) => setValues(date)}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "1.5px" }}>
                <FormControl fullWidth size="small">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Till"
                      slotProps={{ textField: { size: "small" } }}
                      value={Values.toDate ? dayjs(Values.toDate) : null}
                      // onChange={(date) => handleDateChange1(date, 'tillDate')}
                      onChange={(date) => handleDateChange(date, 'toDate')}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
            </Grid>

            <Grid item xs={4}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel >Added By</InputLabel>
                <Select
                  // labelId="resource-label"
                  label="Added By"
                  value={Values.addedBy}
                  onChange={(e) => setValues({ ...Values, addedBy: e.target.value })}
onOpen={allUsers}
                >
                  {resourData.map((item, index) => (
                    <MenuItem key={index} value={item?.addedById}
                    style={{ color: item?.status === 'inactive' ? 'red' : '' }}
                    >
                      {item?.addedBy}
                    </MenuItem>  
                  ))}
                  {/* <MenuItem value={"Tony"}>Tony</MenuItem>
          <MenuItem value={"Tom"}>Tom</MenuItem>
          <MenuItem value={"Stark"}>Stark</MenuItem>
          <MenuItem value={"Homelander"}>Homelander</MenuItem> */}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>


              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Values.status}
                  // value={formValues.domain}
                  label="Status"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => setValues({ ...Values, status: e.target.value })}
                >
                  {/* {Domains.map((item) => {
            return <MenuItem value={item}>{item}</MenuItem>
          })} */}

                  <MenuItem value={"Active"}>Active</MenuItem>
                  <MenuItem value={"On Hold"}>On Hold</MenuItem>
                  <MenuItem value={"Inactive"}>Inactive</MenuItem>
                  {/* <MenuItem value={"Inactive"}>Inactive</MenuItem> */}


                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              {/* <TextField
                label="Domain"
                variant="outlined"
                fullWidth
                // margin="dense"
                size="small"
                value={formValues.domain}
                onChange={(e) => setFormValues({ ...formValues, domain: e.target.value })}
              /> */}

              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">Domain</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={Values.domain}
                  // value={formValues.domain}
                  label="Domain"
                  // InputLabelProps={{ shrink: true }}
                  onChange={(e) => setValues({ ...Values, domain: e.target.value })}
                >
                  {Domains.map((item) => {
                    return <MenuItem value={item}>{item}</MenuItem>
                  })}

                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} textAlign="center" sx={{ marginTop: "5px" }}>
              <Button color="custom" variant="contained" size="small"
                onClick={() => { CommonSearcFun(); handleSearchClose(); funcc(); sendDataToParent1() }}
              >
                Search
              </Button>
              <Button color="custom" variant="contained" size="small"
                sx={{ marginLeft: '12px' }}
                onClick={clearInputField}
              >
                Clear All
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}

